<template>
  <div v-loading="loading" class="taskCreate" element-loading-background="rgba(0, 0, 0, 0.6)"
    element-loading-spinner="el-icon-loading" element-loading-text="文件正在上传.....">
    <!--任务单名称-->
    <div class="header">
      <span>
        <i style="color: red">*</i>
        名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称:
      </span>
      <el-input v-model="taskData.TaskName" placeholder="请输入任务单名称" style="width: 400px" size="small"></el-input>
      <el-checkbox v-model="taskData.IsScore" :false-label="0" :true-label="1" style="margin-left: 40px"
        @change="taskIsScoreChange">
        计分制
      </el-checkbox>
      <el-button v-if="taskData.IsScore == 1" size="mini" style="margin-left: 30px" @click="handleScoreClick">
        设置题目分值
      </el-button>
    </div>
    <!--出题方式-->
    <div class="header">
      <span>
        <i style="color: red">*</i>
        出题方式:
      </span>
      <el-radio-group v-model="taskData.isOnline" :disabled="taskData.TaskListID !== 0 && taskData.isOnline != 0"
        @change="changeTaskType">
        <el-radio :label="1" style="line-height: 28px">在线出题</el-radio>
        <el-radio :label="2" style="line-height: 28px">传题选题</el-radio>
        <el-radio :label="3" style="line-height: 28px">教辅选页</el-radio>
        <el-radio :label="4" style="line-height: 28px">智能组题</el-radio>
      </el-radio-group>
    </div>
    <div class="header">
      <span>
        <i style="color: red">*</i>
        纸张大小:
      </span>
      <el-select v-model="taskData.SizeType" size="small" class="select-size" placeholder="请选择"
        @change="changeSizeType">
        <el-option v-if="taskData.isOnline == 3" :value="1" label="原教辅大小"></el-option>
        <el-option :value="2" label="A4"></el-option>
        <el-option :value="3" label="B5"></el-option>
        <el-option :value="4" label="自定义"></el-option>
      </el-select>
      <el-input v-if="taskData.SizeType > 1" v-model="TrueWidth" size="small" placeholder="宽" @input="SizeChange">
        <i slot="suffix">毫米</i>
      </el-input>
      <el-input v-if="taskData.SizeType > 1" v-model="TrueHeight" size="small" placeholder="高" @input="SizeChange">
        <i slot="suffix">毫米</i>
      </el-input>
      <template v-if="taskData.isOnline == 1 || taskData.isOnline == 4">
        <span>
          <i style="color: red">*</i>
          页边距:
        </span>
        <el-input-number v-model="taskData.PaddingWidth" :max="20" :min="0" controls-position="right" label="页边距"
          size="small" @change="PaddingWidthChange"></el-input-number>
        <i slot="suffix">毫米</i>
      </template>

      <el-button size="mini" style="margin-left: 30px" type="primary" @click="saveTask(true)">保存</el-button>
      <el-button size="mini" @click="printTask">打印</el-button>
      <el-button size="mini" @click="downloadTask">导出</el-button>
    </div>

    <!--    出题开始-->
    <div v-show="taskData.TaskListID && taskData.isOnline > 0" class="question">
      <div class="btns">
        <div :style="{
          width:
            (taskData.TrueWidth > 0
              ? taskData.TrueWidth
              : taskPages.length > 0
                ? taskPages[paginationOpt.currentPage - 1].PageWidth
                : 210) + 'mm',
        }" class="btns-left">
          <!--          <el-button-group>-->
          <!--            <el-button size="mini" :class="{active:isEditQuestion}" @click="setQuestionType(true)">在线出题</el-button>-->
          <!--            <el-button size="mini" :class="{active:!isEditQuestion}" @click="setQuestionType(false)">传题选题</el-button>-->
          <!--            <el-button size="mini" >教辅选页</el-button>-->
          <!--          </el-button-group>-->
          <el-pagination v-show="taskData.isOnline != 1" id="taskPagesId" :current-page.sync="paginationOpt.currentPage"
            :page-size="paginationOpt.pageSize" :pager-count="paginationOpt.pageCount" :total="paginationOpt.total"
            background layout="pager, slot" @current-change="taskPageChange">
            <el-button size="mini" style="background: #409eff; color: #fff" @click="delTaskPage">删除当前页</el-button>
          </el-pagination>
          <input v-if="upIpt" v-show="false" id="upAssistImg" :accept="upAssistImgAccess" :multiple="multiple"
            type="file" @change="upImgChange" />
          <div>
            <el-button v-show="taskData.isOnline == 3" :disabled="taskPages.length >= limit" size="mini" type="primary"
              @click="teachingAuxiliary">
              选择教辅资料
            </el-button>
            <el-tooltip v-show="taskData.isOnline == 2" class="item" :content="'最多' + limit + '页题目'" effect="light"
              placement="right">
              <el-button id="cloudModBtn" :disabled="taskPages.length >= limit" size="mini" type="primary"
                @click="upImgProgress">
                选择题目文件
              </el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="otherBtns"></div>
      </div>
      <div class="taskCut">
        <div class="cut">
          <!--自主出题开始-->
          <div v-show="taskData.isOnline == 1" :style="{
            width: taskData.TrueWidth + 20 + 'mm',
            minWidth: taskData.TrueWidth + 20 + 'mm',
          }" class="autoQuestion">
            <div id="editorCreateTools" class="editorCreateTools">
              <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                :mode="mode" />
            </div>
            <div class="editorCreate">
              <!--正常带按钮的展示开始-->
              <div v-show="taskData.Questions && taskData.Questions.length > 0"
                :style="{ padding: taskData.PaddingWidth + 'mm 0' }" class="Questions w-e-text-container">
                <div v-for="(item, i) in taskData.Questions" :key="i"
                  :style="{ padding: '0 ' + taskData.PaddingWidth + 'mm' }" class="question-item w-e-text">
                  <div v-if="questionPageCount(i)" :style="{ height: taskData.PaddingWidth * 2 + 'mm' }"
                    class="splitPage">
                  </div>
                  <div :class="{
                    active: activeQuestionIndex >= 0 && activeQuestionIndex === i,
                  }" class="questionContent" @click.stop="reviewQuestionItem(item, i)">
                    <div v-if="i === 0 || questionPageCount(i)" :style="{
                      top: -1 * taskData.PaddingWidth + 'mm',
                      left: -1 * taskData.PaddingWidth + 'mm',
                      right: -1 * taskData.PaddingWidth + 'mm',
                      height: taskData.PaddingWidth + 'mm',
                      lineHeight: taskData.PaddingWidth + 'mm',
                    }" style="
                        position: absolute;
                        left: 0;
                        right: 0;
                        color: #000;
                        text-align: center;
                        height: 10mm;
                        font-size: 10px;
                        line-height: 10mm;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        border-top: 1px solid #ddd;
                      ">
                      {{ chapter }}
                    </div>
                    <div :id="'questionHtml' + i" class="questionHtml" v-html="item.QuestionStem"></div>
                    <button v-if="item.PushCount && item.PushCount > 0" :title="'已预设了' + item.PushCount + '道推题'"
                      class="push-count" @click="openPushed(item, i)">
                      {{ item.PushCount }}
                    </button>
                    <div class="btns">
                      <div class="btn">
                        <a title="编辑" @click.prevent="editOnlineQuestion(item)">
                          <i class="el-icon-edit"></i>
                          编辑
                        </a>
                        <a title="删除" @click.prevent="delOnlineQuestion(item)">
                          <i class="el-icon-delete"></i>
                          删除
                        </a>
                        <a v-show="i !== 0" title="上移" @click.prevent="moveOnlineQuestion(item, i, -1)">
                          <i class="el-icon-top"></i>
                          上移
                        </a>
                        <a v-show="i !== taskData.Questions.length - 1" title="下移"
                          @click.prevent="moveOnlineQuestion(item, i, 1)">
                          <i class="el-icon-bottom"></i>
                          下移
                        </a>
                        <a title="相似题" @click.prevent="openSimilar(item, i)">
                          <i class="el-icon-search"></i>
                          相似题
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--正常带按钮的展示结束-->

              <!--显示之用开始-->
              <div v-show="true" class="Questions showQuestion w-e-text-container">
                <div :style="{
                  width: taskData.TrueWidth - taskData.PaddingWidth * 2 + 'mm',
                  minWidth: taskData.TrueWidth - taskData.PaddingWidth * 2 + 'mm',
                }" class="question-item w-e-text">
                  <div class="questionContent">
                    <div id="showQuestion" class="questionHtml" v-html="html"></div>
                  </div>
                </div>
              </div>
              <!--显示之用结束-->
              <!--编辑题目题干开始-->
              <Editor id="editorCreateContainer" class="editorCreateContainer"
                :style="{ padding: '0 ' + taskData.PaddingWidth + 'mm' }" style="
                  min-height: 120px;
                  overflow-y: hidden;
                  margin: 0 10mm;
                  border-top: 30px solid #f9f9f9;
                " v-model="html" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated"
                @customPaste="(editor, event, id) => onCustomPaste(editor, event, 'editorCreateContainer')"
                @onFocus="leaveOnlineQuestion" />
              <div class="saveQuestion">
                <div class="dv">
                  <span style="font-size: 10px; color: #f00">暂时不支持一题多页显示</span>
                  <el-button v-if="taskData.isOnline == 1 && !isReviewOnline" :disabled="btnDisable" size="mini"
                    type="primary" @click="saveQuestion">
                    保存题目
                  </el-button>
                  <el-button v-if="onlineQuestionStatus" :disabled="btnDisable" size="mini" type="warning"
                    @click="clearOnlineEdit">
                    取消编辑
                  </el-button>
                </div>
              </div>
              <!--编辑题目题干结束-->
            </div>
          </div>
          <!--自主出题结束-->

          <!--教辅截题开始-->
          <div v-if="!(taskType == 1)" class="imageQuestion">
            <div class="cutImgQuestion">
              <div id="cutImgs" :style="{
                width:
                  (taskData.TrueWidth > 0
                    ? taskData.TrueWidth
                    : taskPages.length > 0 && taskPages[paginationOpt.currentPage - 1].PageWidth
                      ? taskPages[paginationOpt.currentPage - 1].PageWidth
                      : 210) + 'mm',
                height:
                  (taskData.TrueHeight > 0
                    ? taskData.TrueHeight
                    : taskPages.length > 0 && taskPages[paginationOpt.currentPage - 1].PageHeight
                      ? taskPages[paginationOpt.currentPage - 1].PageHeight
                      : 297) + 'mm',
              }" class="cutImg">
                <vue-cropper v-if="!isNumChange" ref="crop"  :activeIndex="activeQuestionIndex" :autoCrop="opt.autoCrop"
                  :autoCropHeight="opt.autoCropHeight" :autoCropWidth="opt.autoCropWidth" :canMove="opt.canMove"
                  :canMoveBox="opt.canMoveBox" :canScale="opt.canScale" :centerBox="opt.centerBox"
                  :enlarge="opt.enlarge" :fixedBox="opt.fixedBox" :full="opt.full" :high="opt.high" :img="opt.img"
                  :info="opt.info" :infoTrue="opt.infoTrue" :original="opt.original" :outputSize="opt.outputSize"
                  :outputType="opt.outputType" :page-question="taskPages[paginationOpt.currentPage - 1]"
                  :set-crop-h="opt.setCorpH" :set-crop-w="opt.setCorpW" :set-offset-x="opt.setOffsetX"
                  :set-offset-y="opt.setOffsetY" @realTime="realTime" @num-change="numChange"
                  @click-question="reviewImgQuestion" @click-dragbox="dragBoxClick" @select-question="selectQuestion"
                  @similar-question="openSimilar" @see-pushed="openPushed"></vue-cropper>
              </div>
            </div>
          </div>
          <!--教辅截题结束-->

          <!--题目列表开始-->
          <div class="cutSeeting">
            <div class="taskSet">
              <!-- 题号拖拽列表 -->
              <div class="question-num-list-wrap">
                <div class="margin-bottom-sm">题号排序：</div>
                <draggable v-model="sortedQuestionList" :options="{ animation: 200 }" @end="onQuestionSortChange"
                  item-key="QuestionID">
                  <transition-group name="flip-list" tag="div" class="question-num-list">
                    <div v-for="item in sortedQuestionList" :key="item.QuestionID" class="question-num-item" @click="onQuestionSortClick(item)">
                      {{ item.QuestionNum }}
                    </div>
                  </transition-group>
                </draggable>
              </div>
              <el-form class="taskForm" label-position="top">
                <el-form-item v-show="false" class="position" label="题目区域的位置及大小：">
                  <div>
                    <span>X:</span>
                    <el-input :disabled="true" :value="question.RegionX" size="mini"></el-input>
                  </div>
                  <div>
                    <span>Y:</span>
                    <el-input :disabled="true" :value="question.RegionY" size="mini"></el-input>
                  </div>
                  <div>
                    <span>W:</span>
                    <el-input :disabled="true" :value="question.RegionW" size="mini"></el-input>
                  </div>
                  <div>
                    <span>H:</span>
                    <el-input :disabled="true" :value="question.RegionH" size="mini"></el-input>
                  </div>
                </el-form-item>

                <el-form-item class="must">
                  <div slot="label">
                    <span>题号：</span>
                  </div>
                  <!-- {{question.QuestionNum}}{{ typeof question.QuestionNum }} -->
                  <el-input v-model="question.QuestionNum" :disabled="isReviewImgQuestion || isReviewOnline"
                    placeholder="请输入题号"></el-input>
                </el-form-item>

                <el-form-item class="must">
                  <div slot="label">
                    <span>题型：</span>
                    <el-button type="text" icon="el-icon-search" size="small" @click="openSearch(question)">
                      搜原题
                    </el-button>
                  </div>
                  <el-select v-model="question.QuestionType" :disabled="isReviewImgQuestion || isReviewOnline"
                    placeholder="请选择" @change="questionTypeChange">
                    <el-option v-for="item in distQuestionTypes" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="难易等级：">
                  <el-select v-model="question.DifficultLvl" :disabled="isReviewImgQuestion || isReviewOnline"
                    placeholder="请选择">
                    <el-option v-for="item in distDifficultLvls" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="知识点：">
                  <element-tree :knowledge-points="question.KnowledgePoints ? question.KnowledgePoints : []"
                    @pointsChanged="pointsChanged"></element-tree>
                  <!-- <el-input
                    v-model="question.KnowledgePoints"
                    :disabled="isReviewImgQuestion || isReviewOnline"
                    :rows="2"
                    placeholder="请输入内容"
                    type="textarea"
                  >
                  </el-input> -->
                </el-form-item>
                <el-form-item class="must" label="正确答案：(填空题/主观题可以不填写)">
                  <div v-if="question.QuestionType === 1">
                    <el-radio-group v-model="question.Answer" :disabled="isReviewImgQuestion || isReviewOnline">
                      <el-radio label="A"></el-radio>
                      <el-radio label="B"></el-radio>
                      <el-radio label="C"></el-radio>
                      <el-radio label="D"></el-radio>
                      <el-radio label="E"></el-radio>
                      <el-radio label="F"></el-radio>
                      <el-radio label="G"></el-radio>
                    </el-radio-group>
                  </div>
                  <div v-if="question.QuestionType === 2">
                    <el-checkbox-group v-model="question.Answer" :disabled="isReviewImgQuestion || isReviewOnline">
                      <el-checkbox label="A"></el-checkbox>
                      <el-checkbox label="B"></el-checkbox>
                      <el-checkbox label="C"></el-checkbox>
                      <el-checkbox label="D"></el-checkbox>
                      <el-checkbox label="E"></el-checkbox>
                      <el-checkbox label="F"></el-checkbox>
                      <el-checkbox label="G"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div v-if="question.QuestionType === 3">
                    <el-radio-group v-model="question.Answer" :disabled="isReviewImgQuestion || isReviewOnline">
                      <el-radio label="T">对</el-radio>
                      <el-radio label="F">错</el-radio>
                    </el-radio-group>
                  </div>
                  <div v-show="question.QuestionType > 3">
                    <script id="UEcontainer1" name="content" type="text/plain"
                      style="width: 100%; height: 100px"></script>
                  </div>
                </el-form-item>
                <el-form-item label="答案解析：">
                  <script id="UEcontainer2" name="content" type="text/plain"
                    style="width: 100%; height: 100px"></script>
                </el-form-item>
                <el-form-item v-if="taskData.IsScore == 1" class="must" label="分值：">
                  <el-input v-model="question.Score" :disabled="isReviewImgQuestion || isReviewOnline"
                    type="number"></el-input>
                </el-form-item>
                <el-form-item>
                  <div style="text-align: center; margin-top: 0">
                    <el-button v-if="taskData.isOnline == 1 && !isReviewOnline" :disabled="btnDisable" size="mini"
                      type="primary" @click="saveQuestion">
                      保存题目
                    </el-button>
                    <el-button v-if="onlineQuestionStatus" :disabled="btnDisable" size="mini" type="warning"
                      @click="clearOnlineEdit">
                      取消编辑
                    </el-button>
                    <el-button v-if="!(taskData.isOnline == 1) && !isReviewImgQuestion" :disabled="btnDisable"
                      size="mini" type="primary" @click="saveImgQuestion">
                      保存题目
                    </el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!--题目列表结束-->
        </div>
      </div>
    </div>
    <!--    出题结束-->

    <!--    设置分值start-->
    <el-dialog :visible.sync="scoreDialogShow" class="score-dialog" title="设置分值" width="800px" append-to-body
      @close="handleScoreDialogClose">
      <h3 slot="title">设置分值</h3>
      <table cellpadding="0" cellspacing="0" class="el-table__header">
        <thead>
          <tr>
            <th width="60">序号</th>
            <th width="120">题型</th>
            <th width="80">难度</th>
            <th>知识点</th>
            <th width="160">设置分数</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="5">总分：{{ totalScore }}分</td>
          </tr>
          <tr v-for="(questionScore, questionIndex) in questionScores" :key="questionIndex">
            <td align="center">{{ taskData.Questions[questionIndex].Sort }}</td>
            <td align="center">
              {{ distQuestionTypes[taskData.Questions[questionIndex].QuestionType - 1].label }}
            </td>
            <td align="center">
              {{
                taskData.Questions[questionIndex].DifficultLvl > 0
                  ? distDifficultLvls[taskData.Questions[questionIndex].DifficultLvl - 1].label
                  : "/"
              }}
            </td>
            <td align="center">
              <p v-if="taskData.Questions[questionIndex].KnowledgePoints">
                <span v-for="(point, pindex) of taskData.Questions[questionIndex].KnowledgePoints"
                  :key="'point' + pindex">
                  {{ point.PointName + " " }}
                </span>
              </p>
              <p v-else>/</p>
            </td>
            <td>
              <input v-model.number="questionScore.score" type="text"
                @input="questionScoreChanged($event, questionIndex)" />
              分
            </td>
          </tr>
        </tbody>
      </table>
      <p slot="footer" class="dialog-footer">
        <el-button round type="primary" @click="handleScoreConfirm">确定</el-button>
        <el-button round type="primary" @click="handleScoreClear">清空</el-button>
        <el-button round type="primary" @click="handleScoreDialogClose">取消</el-button>
      </p>
    </el-dialog>
    <!--    设置分值end-->
    <!--选择教辅资料开始-->
    <el-dialog :visible.sync="teachingAuxiliaryDialog" id="teachingAuxiliaryDialog" width="90%" append-to-body
      @close="resetTeachingAuxiliary">
      <div slot="title" class="headTitle">
        <i class="el-icon-back" @click="showPage = false"></i>
        教辅资料
      </div>
      <div class="teachingAuxiliaryDialogBody">
        <div v-show="!showPage" class="condition">
          <el-button v-for="(sl, i) in scopeLevelData" :key="i" :class="{ btnSel: i === selScopeLevel }" round
            size="mini" @click="getExerciseBookList((selScopeLevel = i), (exerPage.currentPage = 0))">
            {{ sl.label }}
          </el-button>
        </div>
        <div v-show="!showPage" class="condition">
          <el-button v-for="(sg, i) in schoolGradeData" :key="i" :class="{ btnSel: i === selSchoolGrade }" plain round
            size="mini" @click="getExerciseBookList((selSchoolGrade = i), (exerPage.currentPage = 0))">
            {{ sg }}
          </el-button>
        </div>
        <div v-show="!showPage" class="condition">
          <el-input v-model="exerciseBookCondition.exerciseName" class="input-with-select" size="small"
            placeholder="请输入搜索的练习册名称">
            <el-button slot="append" icon="el-icon-search" @click="getExerciseBookList"></el-button>
          </el-input>
          <el-button type="primary" size="small" style="margin-left: 20px" @click="addExerciseBook">
            添加教辅书
          </el-button>
        </div>
        <div v-show="showPage" class="pageCondition">
          <span>选择的页码 :</span>
          <el-select ref="selPages" v-model="selPages" multiple :placeholder="'请选择页码,最多' + limit + '页'"
            popper-class="selList" @change="selPagesChange">
            <el-option v-for="(item, i) in pagesList" :key="i" :label="item.PageNo.toString()"
              :value="item.Id"></el-option>
          </el-select>
          <el-button type="primary" @click="createTeachingAuxiliary">确认</el-button>
        </div>
        <!--练习册-->
        <div v-show="!showPage">
          <img-text :exer-data="exerData" :exer-page="exerPage" :exer-type="'1'" :sel-scope-level="selScopeLevel"
            @exer-page-change="exerPageChange" @sel-exer-show="selExerShow" @delete-book="deleteBook"></img-text>
        </div>
        <!--练习页-->
        <div v-show="showPage">
          <img-text :exer-type="'2'" :pages-data="pagesData" :pages-page="pagesPage" @sel-page="checkBoxPage"
            @pages-page-change="pagesPageChange"></img-text>
        </div>
      </div>
    </el-dialog>
    <!--选择教辅资料结束-->

    <!--导出用的显示开始-->
    <div id="questionsPrint" :class="{ reviewQuestion: reviewQuestion }" :style="{
      width: taskData.TrueWidth + 'mm',
      height: taskData.TrueHeight + 'mm',
    }" class="Questions questionsPrint w-e-text-container" @scroll="reviewQuestionScroll($event)">
      <div v-for="(item, i) in taskData.Questions" :key="i" :style="{
        width: taskData.TrueWidth + 'mm',
        minWidth: taskData.TrueWidth + 'mm',
      }" class="question-item questionsPrintItem w-e-text">
        <div v-if="questionPageCount(i)" class="splitPage"></div>
        <div class="questionContent" :style="{
          padding: taskData.PaddingWidth ? '0 ' + taskData.PaddingWidth + 'mm' : '0 10mm',
        }">
          <div class="questionHtml" v-html="item.QuestionStem"></div>
        </div>
      </div>
    </div>
    <div id="question2ImgForPrint" :style="{
      width:
        (taskData.TrueWidth > 0 ? taskData.TrueWidth : taskPages.length > 0 ? taskPages[0].PageWidth : 210) + 'mm',
      height:
        (taskData.TrueHeight > 0 ? taskData.TrueHeight : taskPages.length > 0 ? taskPages[0].PageHeight : 297) + 'mm',
    }" class="question2ImgForPrint"></div>
    <!--导出用的显示结束-->

    <!--    题目打印开始-->
    <iframe name="printIFrame" style="visibility: hidden"></iframe>
    <!--    题目打印结束-->

    <!--    添加云任务单-->
    <el-dialog v-if="cloudTask" :fullscreen="true" :modal="false" :visible.sync="cloudTask" title="云任务单选题" top="6vh"
      @close="cloudQuestionClose">
      <task-add :chapter-id="taskData.ChapterID" :teaching-plan-id="taskData.TeachingPlanID" task-type="2"></task-add>
    </el-dialog>
    <!-- 添加云任务单end -->
    <!-- 搜题start -->
    <el-dialog title="提示" custom-class="searchDialog" width="900px" :visible.sync="searchDialog" :append-to-body="true"
      top="10vh" v-dialogDrag :close-on-click-modal="false" style="overflow: hidden" @close="searchData = []">
      <div slot="title" class="searchTitle similar-title">
        <span style="font-size: 20px">搜题</span>
        <div class="extra-btns">
          <el-button class="enter-question-selection" type="primary" size="small"
            @click="enterSelectQuestion">题库挑题</el-button>
          <el-checkbox style="color: #fff" v-model="autoSearchClosed" @change="autoSearchChange">
            关闭自动搜题
          </el-checkbox>
        </div>
      </div>
      <!-- 搜题列表 -->
      <question-bank-list :questions="searchData" :typeName="'searchData'" :needFill="true" :pushEnable="true"
        @fillQueForm="fillQueForm" @similarQuestions="similarQuestions" @removePush="removePush" @addPush="addPush"
        @editQuestion="openPushEdit"></question-bank-list>
    </el-dialog>
    <!-- 搜题end -->

    <!-- 相似题start -->
    <el-dialog title="提示" custom-class="searchDialog" width="900px" :visible.sync="similarDialog" :append-to-body="true"
      top="10vh" v-dialogDrag :close-on-click-modal="false" style="overflow: hidden" @close="closeSimilar">
      <div slot="title" class="searchTitle similar-title">
        <span style="font-size: 20px">相似题</span>
        <div class="extra-btns">
          <el-button class="enter-question-selection" type="primary" size="small"
            @click="enterSelectQuestion">题库挑题</el-button>
          <a v-if="anotherGroupCount < 5" href="#" class="change-one" @click="changeSimilar">
            <i class="el-icon-refresh"></i>
            换一批
          </a>
        </div>
      </div>
      <!-- 相似题列表 -->
      <question-bank-list :questions="similarData" :typeName="'similarData'" :pushEnable="true"
        @similarQuestions="similarQuestions" @removePush="removePush" @addPush="addPush"></question-bank-list>
    </el-dialog>
    <!-- 相似dialog end -->

    <!-- 加入推题的试题列表dialog -->
    <el-dialog title="提示" custom-class="searchDialog" width="900px" :visible.sync="pushedDialog" :append-to-body="true"
      top="10vh" v-dialogDrag :close-on-click-modal="false" style="overflow: hidden" @close="pushedData = []">
      <div slot="title" class="searchTitle">
        <span style="font-size: 20px">预设的推题</span>
        <a href="#" class="change-one" @click="clearPushed">
          <i class="el-icon-refresh"></i>
          全部移出
        </a>
      </div>
      <!-- 已加入推题的列表 -->
      <question-bank-list :questions="pushedData" :typeName="'pushedData'" :editable="true" :pushEnable="true"
        @fillQueForm="fillQueForm" @similarQuestions="similarQuestions" @removePush="removePush" @addPush="addPush"
        @editQuestion="openPushEdit"></question-bank-list>
    </el-dialog>
    <!-- 加入推题的试题列表dialog end -->

    <!-- 推题变式编辑dialog -->
    <el-dialog title="提示" custom-class="searchDialog" width="900px" :visible.sync="editDialog" :append-to-body="true"
      top="5vh" v-dialogDrag :close-on-click-modal="false" style="overflow: hidden" @close="closePushEdit">
      <div slot="title" class="searchTitle">
        <span style="font-size: 20px">变式编辑</span>
      </div>
      <!-- 推题变式编辑表单 -->
      <question-bank-edit :question="pushChangeQue" :editable="true" @save="savePushChanged"
        @cancel="cancelPushChanged"></question-bank-edit>
    </el-dialog>
    <!-- 推题变式编辑dialog end -->


    <!-- 题库挑题dialog -->
    <el-dialog title="提示" custom-class="searchDialog sel-question-dialog" width="80%" top="5vh"
      :visible.sync="selQuestionDialog" :append-to-body="true" :close-on-click-modal="false" style="overflow: hidden"
      @close="closeSelQuestion">
      <div slot="title" class="searchTitle">
        <span style="font-size: 20px">题库挑题</span>
      </div>
      <selQuestion v-if="selQuestionDialog" :taskData="taskData" :question="searchDialog ? question : similarQuestion">
      </selQuestion>
    </el-dialog>
  </div>
</template>

<script>

import draggable from 'vuedraggable';

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import VueCropper from "../vue-cropper/index";
import WE from "wangeditor";
import imgText from "../exercise/imgText";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
/* import "../../assets/css/questionStyle.css";
import "../../assets/js/library.js"; */
import ElementTree from "./ElementTree.vue";
import QuestionBankList from "./QuestionBankList.vue";
import QuestionBankEdit from "./QuestionBankEdit.vue";
import selQuestion from './selQuestion.vue'
import store from "@/store/store.js";
export default {
  name: "TaskCreate",
  components: {
    draggable,
    VueCropper,
    WE,
    imgText,
    Editor,
    Toolbar,
    ElementTree,
    QuestionBankList,
    QuestionBankEdit,
    selQuestion
  },
  props: {
    chapter: String, //选择的章节,标题...
    taskID: {
      type: Number,
      default: 0
    },
    taskType: {
      type: [Number, String],
      default: 0
    },
    teachingPlanID: {
      type: Number,
      default: 0
    }
    /* taskData: {
      //数据存于父级.
      type: Object,
      required: true,
      //任务单
      default: {
        TaskListID: 0, //任务单id,
        TaskName: "", //任务单的名称
        ChapterID: "", //章节id
        TeachingPlanID: "", //课时ID
        IsScore: 0, //是否计分制
        isOnline: 1, //1在线出题、2传题选题、3教辅选页、4智能组卷
        SizeType: 2, //纸张类型
        TrueWidth: 210, //纸张尺寸宽度
        TrueHeight: 297, //纸张尺寸高度
        PaddingWidth: 10, //页边距，整型，单位毫米
        Questions: [], //题目数组
      },
    },
    taskPages: Array, */
  },
  data() {
    return {
      taskData: {
        TaskListID: 0, //任务单id,
        TaskName: "", //任务单的名称
        ChapterID: "", //章节id
        TeachingPlanID: "", //课时ID
        IsScore: 0, //是否计分制
        isOnline: 1, //1在线出题、2传题选题、3教辅选页、4智能组卷
        SizeType: 2, //纸张类型
        TrueWidth: 210, //纸张尺寸宽度
        TrueHeight: 297, //纸张尺寸高度
        PaddingWidth: 10, //页边距，整型，单位毫米
        Questions: [], //题目数组
      },
      taskPages: [],
      /*题目难易程度字典*/
      distDifficultLvls: [
        {
          value: 1,
          label: "容易",
        },
        {
          value: 2,
          label: "较易",
        },
        {
          value: 3,
          label: "一般",
        },
        {
          value: 4,
          label: "较难",
        },
        {
          value: 5,
          label: "困难",
        },
      ],
      /*题目类型字典*/
      distQuestionTypes: [
        {
          value: 1,
          label: "单选题",
        },
        {
          value: 2,
          label: "多选题",
        },
        {
          value: 3,
          label: "判断题",
        },
        {
          value: 4,
          label: "填空题/主观题",
        },
      ],
      /*纸张类型字典*/
      SizeTypes: [
        { value: 1, name: "原教辅尺寸" },
        { value: 2, name: "A4" },
        { value: 3, name: "B5" },
        { value: 4, name: "自定义" },
      ],
      /*全局共用的 */
      loading: false,
      myurl: window.url, //接口hostURL

      /*任务单基础属性*/
      TrueWidth: 210, //纸张尺寸宽度输入框的值
      TrueHeight: 297, //纸张尺寸高度输入框的值
      questionsRegionChanged: false, //由于纸张大小、页边距等变化导致题目区域x\y\w\h值改变的标记，true即为改变了，改变了的需要调接口保存变化后的值

      isEditQuestion: true, //true,在线出题,false,图片框题,
      // 当前编辑的题目,在线出题,传题选题共用.
      question: {
        // 任务单部分
        TaskListID: "", //任务单的id
        SID: "", //关联题库试题ID
        ID: 0, //题目id
        QuestionType: "", //题目类型
        Answer: [], //答案
        Explain: "", //解析
        DifficultLvl: "", //难易度
        KnowledgePoints: [], //知识点
        Score: "", //分数
        Sort: "", //排序
        //编辑题目独有
        QuestionStem: "", //题干文本.
        // 图片题目独有
        QuestionStemImage: "", //题干图片
        RegionX: "",
        RegionY: "",
        RegionW: "",
        RegionH: "",
        AnswerAreaRows: "", // 增加的高度行
        AreaHeight: "", //  整个题的高度
      },
      showQuestion: null,
      activeQuestionIndex: -1, //选中的题目index

      html: "", //在线出题题干文本框内容
      editor: null, // 在线出题题干编辑器
      answerUEditor: null, // 正确答案编辑器
      explainUEditor: null, //答案解析编辑器

      toolbarConfig: {
        toolbarKeys: [
          {
            key: "group-header-style", // 必填，要以 group 开头
            title: "标题", // 必填
            //iconSvg: '<svg>....</svg>', // 可选
            menuKeys: ["header1", "header2", "header3", "header4", "header5"], // 下级菜单 key ，必填
          },
          "bold",
          {
            key: "group-font-style", // 必填，要以 group 开头
            title: "文字样式", // 必填
            menuKeys: ["fontSize", "fontFamily", "lineHeight"],
          },
          "italic",
          "underline",
          "through",
          "indent",
          "color",
          "bgColor",
          "insertLink",
          "justifyCenter",
          "uploadImage",
          "insertTable",
          "divider",
          "undo",
          "redo",
        ],
        //excludeKeys:["header1","header2","header3",'indent',"justifyLeft","justifyRight","insertVideo"]
      },
      editorConfig: {
        placeholder: "请输入内容",
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImg,
          },
        },
      },
      mode: "simple", // or 'simple'
      cloudTask: false, //云任务单选题对话框显示or不显示
      onlineQuestionStatus: false, //记录是否在在线出题状态. 取消编辑按钮是否加载.
      isReviewOnline: false, //在线出题题目预览状态
      //老版本wangeditor的编辑器内容
      // editorCreate: null,

      /*传题选题开始*/
      upAssistImg: "", //上传文件的input
      upAssistImgAccess: "image/*", //默认是图片.
      upIpt: true, //是否加载Dom,
      multiple: true, //是否选择多个.
      limit: 40,
      //上传文件时的格式验证正则
      reg: null,
      cloudModBtn: "", //上传图片按钮dom
      cutImgs: null,
      paginationOpt: {
        currentPage: 1, //当前第几页
        pageSize: 1, //每页显示几个
        pageCount: 11, //多少页时收缩
        total: 0, //总数量.
      },
      editNowPage: 0, //选中的页码
      opt: {
        // img:'static/page11.jpg',
        img: "",
        setCorpW: 0,
        setCorpH: 0,
        setOffsetX: 0,
        setOffsetY: 0,
        canMove: false, //	后面的背景图是否可以移动.
        original: false, //	上传图片按照原始比例渲染
        canScale: false, //	图片是否允许滚轮缩放
        canMoveBox: true, //	截图框能否拖动
        fixedBox: false, //	固定截图框大小 不允许改变
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: 200, //	默认生成截图框宽度 	容器的80% 	0~max
        autoCropHeight: 50, //	默认生成截图框高度 	容器的80% 	0~max
        outputSize: 0.8, //	裁剪生成图片的质量 	1 	0.1 - 1
        outputType: "jpg", //	裁剪生成图片的格式 	jpg (jpg 需要传入jpeg)
        info: true, //裁剪框的大小信息
        full: true, //是否输出原图比例的截图
        centerBox: false, //	截图框是否被限制在图片里面
        high: true, //是否按照设备的dpr 输出等比例图片
        infoTrue: true, //	true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 1, //	图片根据截图框输出比例倍数 	1 	0-max(建议不要太大不然会卡死的呢)
        mode: "210mm,297mm", //	图片默认渲染方式 	contain 	contain , cover, 100px, 100% auto
      },
      isNumChange: false,
      //预览图片题目
      isReviewImgQuestion: false,
      reviewQuestion: false, //任务单预览
      newTop: 0,
      /*传题选题结束*/

      btnDisable: false, //防止重复点击保存题目按钮,意禁用置灰的状态

      scoreDialogShow: false, //设置分值对话框显示
      totalScore: 0, //总分
      questionScores: [
        //各题目分值
        /*{
         "questionId": 7,
         "score": 0,
         }*/
      ],

      /*选择教辅资料*/
      teachingAuxiliaryDialog: false, //教辅选择窗口.
      teachingAuxiliaryCondition: {
        searchText: "",
      },
      /*选择教辅资料*/

      ////教辅资料
      scopeLevelData: [
        { label: "全部", value: "" },
        { label: "最近使用", value: "0" },
        { label: "我的收藏", value: "1" },
        { label: "我的练习册", value: "2" },
        { label: "全网资源", value: "3" },
        { label: "本校资源", value: "4" },
      ],
      ////
      schoolGradeData: [
        "全部",
        "一年级",
        "二年级",
        "三年级",
        "四年级",
        "五年级",
        "六年级",
        "七年级",
        "八年级",
        "九年级",
        "高一",
        "高二",
        "高三",
        "小升初",
        "中考",
        "高考",
      ],
      selScopeLevel: 0,
      selSchoolGrade: 0,
      ////教辅条件
      exerciseBookCondition: {
        pageindex: 0,
        pageSize: 12,
        scopeLevel: "",
        gradeName: "",
        exerciseName: "",
      },
      exerData: [],
      exerPage: {
        currentPage: 0,
        pageSize: 12, //每页多少行
        total: 15, //总行数
        pageCounter: 11, //折叠数,只能为单数....神奇啊
      },
      pagesData: {
        currentPage: 0,
        datalist: [],
        pageSize: 12,
        totalSize: 200,
      },
      pagesPage: {
        currentPage: 1,
        pageSize: 12, //每页多少行
        total: 200, //总行数
        pageCounter: 11, //折叠数,只能为单数....神奇啊
      },
      pagesCondition: {
        pageindex: 0,
        pageSize: 12,
        exerciseId: "",
      },
      showPage: false,
      selPages: [], //选择的练习页.
      pagesList: [{ Id: 0, PageNo: 0 }], //所有页的id.
      /* 搜题\相似题相关 start------ */
      searchDialog: false, //搜索框是否显示
      autoSearchClosed: true, //关闭自动搜题标记：false不关闭，true关闭
      searchData: [
        /* {
          Data: {},
          Answers: [],
          Options: [],
          SourceReports: [],
          QuestionChidren: [],
          PushID: 0
        } */
      ], //题目数组
      similarDialog: false,
      similarData: [
        /* {
          Data: {},
          Answers: [],
          Options: [],
          SourceReports: [],
          QuestionChidren: [],
          PushID: 0
        } */
      ],
      similarQuestion: null,
      similarLoadedData: [],
      anotherGroupCount: 0,
      pushedDialog: false,
      pushedData: [],
      optNums: ["A", "B", "C", "D", "E", "F", "G"],
      /* 搜题/相似题相关 end-------- */
      /* 已推提变式编辑相关 start--------------- */
      pushChangeIndex: -1,
      pushChangeQue: {},
      editDialog: false,
      /* 已推提变式编辑相关 end---------------- */

      /* 题库挑题  */
      selQuestionDialog: false,

      sortedQuestionList: [],

    };
  },

  methods: {
    // 调试：检查 UEditor 后端配置
    checkUEditorConfig() {
      const configUrl = window.hosturl + "/UEditor/Handler?action=config";
      console.log("正在检查 UEditor 配置接口:", configUrl);
      
      this.axios.get(configUrl)
        .then(res => {
          console.log("UEditor 配置接口返回:", res.data);
          if (typeof res.data === 'string') {
            console.error("❌ 错误：后端返回的是字符串，不是 JSON 对象");
            console.log("返回内容:", res.data);
          } else if (res.data && typeof res.data === 'object') {
            console.log("✅ 后端返回的是 JSON 对象");
            // 检查必需的配置项
            const requiredKeys = ['imageActionName', 'imageFieldName', 'imageMaxSize', 'imageAllowFiles'];
            const missingKeys = requiredKeys.filter(key => !res.data[key]);
            if (missingKeys.length > 0) {
              console.warn("⚠️ 缺少必需的配置项:", missingKeys);
            } else {
              console.log("✅ 配置项完整");
            }
          }
        })
        .catch(err => {
          console.error("❌ 请求 UEditor 配置接口失败:", err);
          if (err.response) {
            console.log("响应状态:", err.response.status);
            console.log("响应数据:", err.response.data);
          }
        });
    },
    
    // 题号点击事件
    onQuestionSortClick(item){
      // console.log(this.taskPages);
      // console.log(this.paginationOpt.currentPage);
      
      // // console.log(index);
      const page =  this.taskPages[this.paginationOpt.currentPage-1]
      // console.log(page);
      const index = page.Questions.findIndex(e => e.ID === item.QuestionID);
      // console.log(index);
      
      if (index!== -1) {
        // 通过索引获取对应的元素
        const foundItem = page.Questions[index];
        // 调用 changeQuestion 方法并传递索引和对应的元素
        // console.log(index,foundItem);
        this.reviewImgQuestion(index, foundItem);
      }
    },
    async onQuestionSortChange(evt) {
      // evt 是拖拽事件对象
      this.sortedQuestionList.forEach((item, idx) => {
        item.Sort = idx + 1;// 把每一项的Sort设置为当前索引+1”
      });
      await this.updateQuestionSort(this.sortedQuestionList);
    },
    async updateQuestionSort(list) {

      // try {
      // 
      // this.$message.success('排序已更新');
      const formData = {
        TaskPageID: this.taskPages[this.paginationOpt.currentPage - 1].PageID, // 教辅页id
        data: list
      }
      console.log('拖拽最终的题号顺序：', formData, window.url);

      this.axios
        .post(window.url + "/UpdateTaskQuestionsSort", formData)
        .then((res) => {
          console.log("作业 - 保存题目列表顺序", res);
          if (res.data.result !== 200) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
            // this.$alert(res.data.message, "提示");
            return;
          }
          this.$message.success(res.data.message || '排序更新成功')
        })
      // } catch (e) {
      //   this.$message.error('排序更新失败');
      // }
    },
    getTeachingMaterialForTeacher() {
      this.axios({
        method: "GET",
        url: window.hosturl + "/hdkt/GetTeachingMaterialForTeacher",
      }).then((res) => {
        let da = res.data.data;
        console.log('获取----', da);

        if (da !== null) {
          let arr = [da.SubjectID, da.EditionID, da.BookID];
          let labels = [da.SubjectName, da.EditionName, da.BookName];

          store.commit("upLastTeachingMaterial", arr);
          store.commit("upLastTeachingMaterialLabels", labels);
        } else {
          store.commit("upLastTeachingMaterial", null);
          store.commit("upLastTeachingMaterialLabels", null);
        }
      })
    },
    //上传图片
    uploadImg(file, insertFn) {
      let imgData = new FormData();
      imgData.append("file", file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.axios.post(window.url + "WangEditorUploadImage", imgData, config).then((response) => {
        insertFn(response.data.data[0].url);
      });
    },
    //出题富文本初始化
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      /* const allMenuKeys = this.editor.getAllMenuKeys();
      console.log(allMenuKeys); */
    },

    onCustomPaste(editor, event, id) {
      let html = event.clipboardData.getData("text/html"); // 获取粘贴的 html
      const rtf = event.clipboardData.getData("text/rtf"); // 获取 rtf 数据（如从 word wsp 复制粘贴）
      //  word wsp 复制粘贴
      if (html && rtf) {
        // event.preventDefault();
        const imgSrcs = this.findAllImgSrcsFromHtml(html); // 从html中查找所有的图片
        // 如果有
        if (imgSrcs && Array.isArray(imgSrcs) && imgSrcs.length) {
          // 阻止默认的粘贴行为
          event.preventDefault();
          //return false;
          // 从rtf内容中查找图片数据
          const rtfImageData = this.extractImageDataFromRtf(rtf);
          // 如果找到
          if (rtfImageData.length) {
            html = this.replaceImagesFileSourceWithInlineRepresentation(html, imgSrcs, rtfImageData);
          }
          this.editor.dangerouslyInsertHtml(html);
        }
      } else {
        return true;
      }
    },
    /**
     * 从html代码中匹配返回图片标签img的属性src的值的集合
     * @param htmlData
     * @return Array
     */
    findAllImgSrcsFromHtml(htmlData) {
      let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
      let arr = htmlData.match(imgReg); //筛选出所有的img
      if (!arr || (Array.isArray(arr) && !arr.length)) {
        return false;
      }
      let srcArr = [];
      for (let i = 0; i < arr.length; i++) {
        let src = arr[i].match(srcReg);
        // 获取图片地址
        srcArr.push(src[1]);
      }
      return srcArr;
    },
    /**
     * 从rtf内容中匹配返回图片数据的集合
     * @param rtfData
     * @return Array
     */
    extractImageDataFromRtf(rtfData) {
      if (!rtfData) {
        return [];
      }

      let regexPictureHeader = /{\\pict[\s\S]+?({\\\*\\blipuid\s?[\da-fA-F]+)[\s}]*/;
      let regexPicture = new RegExp("(?:(" + regexPictureHeader.source + "))([\\da-fA-F\\s]+)\\}", "g");
      let images = rtfData.match(regexPicture);
      let result = [];
      if (images) {
        for (const image of images) {
          let imageType = false;

          if (image.includes("\\pngblip")) {
            imageType = "image/png";
          } else if (image.includes("\\jpegblip")) {
            imageType = "image/jpeg";
          }

          if (imageType) {
            result.push({
              hex: image.replace(regexPictureHeader, "").replace(/[^\da-fA-F]/g, ""),
              type: imageType,
            });
          }
        }
      }

      return result;
    },
    hexToFile(obj) {
      // 将十六进制字符串转成字节数组
      const bytes = obj.hex.match(/.{1,2}/g).map((byte) => parseInt(byte, 16));

      // 从字节数组创建一个Blob对象
      const blob = new Blob([new Uint8Array(bytes)], { type: obj.type });

      // 从Blob创建一个File对象
      const file = new File([blob], "hahha.png", { type: obj.type });
      let formData = new FormData();
      formData.append("file", file);
      return formData;
    },
    replaceImagesFileSourceWithInlineRepresentation(htmlData, imageSrcs, imagesHexSources, isBase64Data = true) {
      if (imageSrcs.length === imagesHexSources.length) {
        for (let i = 0; i < imageSrcs.length; i++) {
          const newSrc = isBase64Data
            ? `data:${imagesHexSources[i].type};base64,${this._convertHexToBase64(imagesHexSources[i].hex)}`
            : imagesHexSources[i];

          htmlData = htmlData.replace(imageSrcs[i], newSrc);
        }
      }

      return htmlData;
    },
    _convertHexToBase64(hexString) {
      return btoa(
        hexString
          .match(/\w{2}/g)
          .map((char) => {
            return String.fromCharCode(parseInt(char, 16));
          })
          .join("")
      );
    },
    /*模拟事件*/
    triggerEvent(element, eventType) {
      let rect = element.getBoundingClientRect();
      let event = new MouseEvent(eventType, {
        clientX: rect.left + 20,
        clientY: rect.top + 10,
        view: window,
        buttons: 1,
        bubbles: true,
      });
      element.dispatchEvent(event);
    },
    //初始化页面
    init() {
      this.upAssistImg = document.getElementById("upAssistImg");
      this.cloudModBtn = document.getElementById("cloudModBtn");
      this.showQuestion = document.getElementById("showQuestion");
      this.getDist();
      if (this.taskID != 0) {
        this.question.TaskListID = this.taskID;
      }
      this.getTaskInfo(this.taskID, this.taskType);
      // console.log('--==-==-=前',this.autoSearchClosed)
      // console.log(localStorage)
      // this.autoSearchClosed =
      //   localStorage["autoSearchClosed"] != null ? Boolean(localStorage["autoSearchClosed"]) : false;
      // console.log('--==-==-=后',this.autoSearchClosed)

      //创建编辑器
      /* this.editor = new WE("#editorCreateTools", "#editorCreateContainer");
      this.editor.config.uploadImgServer = window.url + "WangEditorUploadImage";
      this.editor.config.fontSizes = {
        "x-small": { name: "一号", value: "7" },
        small: { name: "二号", value: "6" },
        normal: { name: "小二", value: "5" },
        large: { name: "三号", value: "4" },
        "x-large": { name: "四号", value: "3" },
        "xx-large": { name: "小四", value: "2" },
        "xxx-large": { name: "五号(默认)", value: "1" }
      };
      this.editor.config.onchangeTimeout = 300;
      this.editor.config.onchange = newHtml => {
        this.showQuestion.innerHTML = newHtml;
      };
      this.editor.config.excludeMenus = [
        "todo",
        "quote",
        "emoticon",
        "video",
        "link"
      ];
      this.editor.create(); */
    },
    getTaskInfo(taskID, isOnline) {
      if (isOnline == 1) {
        this.isEditQuestion = true;
        this.axios
          .post(window.url + "GetTaskListAndQuestionList", {
            TaskListID: taskID,
            TeachingPlanID: this.teachingPlanID,
          })
          .then((res) => {
            //异常处理.
            if (res.data.result !== 200) {
              this.$message({
                message: res.data.message,
                type: "error",
              });
              return;
            }
            //获取正常数据.
            this.taskData = res.data.data;
            if (this.taskData.SizeType == 0) {
              this.taskData.SizeType == 2;
              this.taskData.TrueWidth = 210;
              this.taskData.TrueHeight = 297;
            }

            if (!this.taskData.PaddingWidth || this.taskData.PaddingWidth == 0) {
              this.taskData.PaddingWidth = 10;
            }

          });
      } else if (isOnline === 2 || isOnline === 3) {
        this.isEditQuestion = false;
        this.axios({
          method: "GET",
          url: window.url + "GetJiaoFuZiLiaoForEdit2",
          params: {
            TaskListID: taskID,
            TeachingPlanID: this.teachingPlanID,
          },
        }).then((res) => {
          //异常处理.
          //console.log("教辅资料2",res);
          if (res.data.result !== 200) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
            return;
          }
          //获取正常数据.
          let resData = res.data.data;
          this.taskData = resData["taskList"];
          //把所有页的题目组合到一个数组中,并按题号排序
          if (!this.taskData.Questions) {
            this.taskData.Questions = [];
          }
          //组合题目.
          this.taskPages = resData["taskPagesAndQuestions"];
          this.taskPages.forEach((item) => {
            let ql = item.Questions;
            if (ql.length > 0) {
              this.taskData.Questions = this.taskData.Questions.concat(ql);
            }
          });
          this.taskData.Questions.sort((a, b) => {
            return a.sort - b.sort;
          });
          if (this.taskData.SizeType == 0) {
            this.taskData.SizeType == 2;
            this.taskData.TrueWidth = 210;
            this.taskData.TrueHeight = 297;
          }
          this.taskData.PaddingWidth = 0;

          this.paginationOpt.currentPage = 1;
          this.paginationOpt.total = this.taskPages.length;
          // 选中的页
          if (this.taskPages.length >= this.paginationOpt.currentPage) {
            let selPage = this.taskPages[this.paginationOpt.currentPage - 1];
            this.opt.img = selPage.PageImage;
          } else {
            this.opt.img = "";
          }
        });
      }
    },

    //在线出题  与  传题选题切换.
    /*setQuestionType(isEditQuestion) {
     let isOnline = this.taskData.isOnline;
     if (isOnline === '') {
     this.isEditQuestion = isEditQuestion;
     if (!isEditQuestion && this.opt.img === '') {
     if (this.taskPages.length === 0) {
     if (this.taskData.TaskListID !== '') {
     this.cloudModBtn.click();
     }
     } else {
     this.opt.img = this.taskPages[0].PageImage;
     this.paginationOpt.total = this.taskPages.length;
     }
     }
     }
     if (isOnline == 1 && isEditQuestion === false) {
     this.$alert(`当前任务单您已选择在线出题的方式，暂无法再使用传题选题的出题方式。`, '提示');
     }
     if (isOnline == 2 && isEditQuestion === true) {
     this.$alert(`您已经传题选题裁题,不再允许在线出题`, '提示');
     }
     },*/

    /*是否计分制修改*/
    taskIsScoreChange() {
      if (this.taskData.TaskListID && this.taskData.isOnline > 0) {
        this.saveTask(false);
      }
    },

    /*改变出题方式*/
    changeTaskType(e) {
      if (this.taskData.isOnline == 1 || this.taskData.isOnline == 4) {
        if (this.taskData.PaddingWidth == 0) {
          this.taskData.PaddingWidth = 10;
        }
      } else {
        this.taskData.PaddingWidth = 0;
      }
      if (this.taskData.isOnline != 3 && this.taskData.SizeType == 1) {
        this.taskData.SizeType = 2;
        this.taskData.TrueWidth = 210;
        this.taskData.TrueHeight = 297;
      }
    },

    /*改变纸张尺寸类型*/
    changeSizeType() {
      switch (this.taskData.SizeType) {
        case 1:
          this.TrueWidth = 0;
          this.TrueHeight = 0;
          break;
        case 2:
          this.TrueWidth = 210;
          this.TrueHeight = 297;
          break;
        case 3:
          this.TrueWidth = 176;
          this.TrueHeight = 250;
          break;
        case 4:
          if (this.TrueWidth == 0) {
            this.TrueWidth = 210;
            this.TrueHeight = 297;
          }
          break;
        default:
          this.TrueWidth = 210;
          this.TrueHeight = 297;
          break;
      }
      this.QuestionRegionChange();
    },

    /*纸张尺寸修改*/
    SizeChange(val) {
      if (this.TrueWidth > 100 && this.TrueHeight > 100) {
        this.QuestionRegionChange();
      }
    },

    /*页边距修改*/
    PaddingWidthChange(currentValue, oldValue) {
      let len = this.taskData.Questions.length;
      if (this.taskData.isOnline == 1 && len > 0) {
        //纸张页边距变化了，自主出题的题目宽高需要重新计算
        this.questionsRegionChanged = true;
        for (let i = 0; i < len; i++) {
          // 计算题目的高度
          let question = this.taskData.Questions[i];
          let questionHtml = document.getElementById("questionHtml" + i);
          let style = getComputedStyle(questionHtml);
          question.RegionW = Math.round((this.taskData.TrueWidth / 210) * 793.69);
          question.RegionH = parseFloat(style.height);
        }
      }
    },

    /*题目区域坐标修改*/
    QuestionRegionChange() {
      if (this.taskData.isOnline == 1) {
        let len = this.taskData.Questions.length;
        //先更改作业的尺寸，dom会变化，计算变化后的题目的宽高
        this.taskData.TrueWidth = this.TrueWidth;
        this.taskData.TrueHeight = this.TrueHeight;
        if (len > 0) {
          //纸张尺寸变化了，自主出题的题目宽高需要重新计算
          this.questionsRegionChanged = true;
          let that = this;
          setTimeout(function () {
            for (let i = 0; i < len; i++) {
              // 计算题目的高度
              let question = that.taskData.Questions[i];
              let questionHtml = document.getElementById("questionHtml" + i);
              let style = getComputedStyle(questionHtml);
              question.RegionW = Math.round((that.taskData.TrueWidth / 210) * 793.69);
              question.RegionH = parseFloat(style.height);
            }
          }, 3000);
        }
      } else if (this.taskData.isOnline == 2 || this.taskData.isOnline == 3) {
        let len = this.taskData.Questions.length;
        if (len > 0) {
          //纸张尺寸变化了，框出的题目位置区域需要等比例缩放
          this.questionsRegionChanged = true;
          for (let page of this.taskPages) {
            let questions = page.Questions;
            let oldWidth = this.taskData.TrueWidth == 0 ? page.PageWidth : this.taskData.TrueWidth;
            let oldHeight = this.taskData.TrueHeight == 0 ? page.PageHeight : this.taskData.TrueHeight;
            let newWidth = this.TrueWidth == 0 ? page.PageWidth : this.TrueWidth;
            let newHeight = this.TrueHeight == 0 ? page.PageHeight : this.TrueHeight;
            for (let question of questions) {
              question.RegionX = Math.floor((question.RegionX / oldWidth) * newWidth * 100) / 100;
              question.RegionY = Math.floor((question.RegionY / oldHeight) * newHeight * 100) / 100;
              question.RegionW = Math.round((question.RegionW / oldWidth) * newWidth);
              question.RegionH = Math.round((question.RegionH / oldHeight) * newHeight);
            }
          }
        }
        this.taskData.TrueWidth = this.TrueWidth;
        this.taskData.TrueHeight = this.TrueHeight;
        this.$refs.crop.reload(); //框题区域重载
      } else {
        this.taskData.TrueWidth = this.TrueWidth;
        this.taskData.TrueHeight = this.TrueHeight;
      }
    },

    saveTask(isOpen) {
      //判断数据完整性.
      if (this.taskData.TaskName === "") {
        this.$alert(`名称不完整,请填写完整后保存`, "提示");
        return;
      }
      if (this.taskData.isOnline == 0) {
        this.$alert(`请选择出题方式`, "提示");
        return;
      }
      if (
        this.taskData.SizeType > 1 &&
        (this.taskData.TrueWidth == 0 ||
          this.taskData.TrueHeight == 0 ||
          this.taskData.TrueWidth == "" ||
          this.taskData.TrueHeight == "")
      ) {
        this.$alert(`请选择纸张大小`, "提示");
        return;
      }
      //是不是在线出题.
      if (this.taskData.isOnline > 1) {
        this.isEditQuestion = false;
      } else {
        this.isEditQuestion = true;
      }
      //保存/更新 接口调用.
      this.axios.post(window.url + "SaveQuestionStem", this.taskData).then((res) => {
        //console.log("保存任务单返回值:", res);
        if (res.data.result !== 200) {
          this.$message({
            message: res.data.message,
            type: "error",
          });
          return;
        }

        let taskListID = res.data.data;
        this.taskData.TaskListID = taskListID;
        this.question.TaskListID = taskListID;

        if (this.questionsRegionChanged) {
          this.updateTaskQuestionRegions();
        } else {
          //获取正常数据.
          if (isOpen) {
            this.$message({
              message: "任务单保存成功",
              type: "success",
            });
          }
        }
      });
    },

    /*提交更新题目区域坐标*/
    updateTaskQuestionRegions() {
      let params = {};
      params.taskId = this.taskData.TaskListID;
      let questionsData = [];
      if (this.taskData.isOnline == 1) {
        for (let i = 0, len = this.taskData.Questions.length; i < len; i++) {
          // 计算题目的高度
          let question = this.taskData.Questions[i];
          questionsData.push({
            exercisePageId: 0,
            pageId: question.PageID,
            questionId: question.ID,
            regionX: 0,
            regionY: 0,
            regionW: question.RegionW,
            regionH: question.RegionH,
          });
        }
      } else if (this.taskData.isOnline == 2 || this.taskData.isOnline == 3) {
        for (let page of this.taskPages) {
          let questions = page.Questions;
          for (let question of questions) {
            questionsData.push({
              exercisePageId: page.ExercisePageId ? page.ExercisePageId : 0,
              pageId: page.ID || page.PageID,
              questionId: question.ID,
              regionX: question.RegionX,
              regionY: question.RegionY,
              regionW: question.RegionW,
              regionH: question.RegionH,
            });
          }
        }
      }

      params.data = questionsData;
      this.axios.post(window.url + "UpdateRegionForChangePaperSize", params).then((res) => {
        if (res.data.result !== 200) {
          this.$message({
            message: res.data.message,
            type: "error",
          });
          return;
        }
        //获取正常数据.
        this.$message({
          message: "已保存",
          type: "success",
        });
        this.questionsRegionChanged = false;
      });
    },

    // 将base64转换成file对象
    dataURLtoFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, { type: mime });
    },

    // 云任务单选题
    cloudQuestion() {
      if (this.question.Edit) {
        this.$alert("当前的题目还未保存.", "提示");
        return;
      }
      //console.log("你好")
      this.cloudTask = true;
    },
    cloudQuestionClose() { },

    //获取字典
    getDist() {
      this.axios.post(window.url + "GetDicForQuestionTypeAndDifficultLvl").then((res) => {
        //console.log("字典", res);
        //异常处理.
        if (res.data.result !== 200) {
          this.$message({
            message: res.data.message,
            type: "error",
          });
          return;
        }
        //获取正常数据.
        this.distDifficultLvls = res.data.data.DifficultLvls;
        this.distQuestionTypes = res.data.data.QuestionTypes;
      });
    },

    //题目切换
    questionTypeChange(item) {
      if (item == 2) {
        this.question.Answer = [];
      }

      if (!this.autoSearchClosed) {
        this.openSearch(this.question);
      }
    },
    /*在线出题和传题选题共用*/

    /*在线出题部分*/
    //在线出题  , 计算当前题目的分页
    questionPageCount(i) {
      let page = 1,
        pageHeight =
          Math.floor(((this.taskData.TrueHeight - this.taskData.PaddingWidth * 2) / 297) * 1122.5 * 100) / 100,
        nowheight = 0;
      for (let j = 0; j <= i; j++) {
        nowheight += this.taskData.Questions[j].RegionH;
        //最后一个,且刚好大于 pageHeight,的倍数.
        if (i === j) {
          let isBig = nowheight > page * pageHeight;
          return isBig;
        }
        //不最最后一个, 则页数加1.
        if (nowheight > pageHeight * page) {
          nowheight = pageHeight * page + this.taskData.Questions[j].RegionH;
          page++;
        }
      }
    },
    //在线出题检测.
    checkQuestion() {
      //1,检测任务单id,为空提示保存任务单
      if (!this.question.TaskListID) {
        this.$alert(`还未保存任务单，请先保存!.`, "提示");
        return false;
      }
      //题号检测
      if (this.question.QuestionNum === "") {
        this.$alert(`请选择题号.`, "提示");
        return false;
      }
      //题型检测
      if (this.question.QuestionType === "") {
        this.$alert(`请选择题目类型.`, "提示");
        return false;
      }

      //答案检测 1 单选, 2 多选 ,3判断, 4 填空, 5 主观题
      // 现在   1 单选 , 2 多选 ,3判断  , 4主观
      if (this.question.QuestionType === 1 || this.question.QuestionType === 3) {
        if (this.question.Answer == "") {
          this.$alert(`答案不能为空.`, "提示");
          return false;
        }
      }
      if (this.question.QuestionType === 2) {
        if (this.question.Answer.length <= 0) {
          this.$alert(`您还没选择复选题的答案.`, "提示");
          return false;
        }
      }

      return true;
    },
    initQuestion() {
      this.question = {
        // 任务单部分
        TaskListID: this.taskData.TaskListID, //任务单的id
        SID: "", //关联题库试题ID
        PushCount: 0,
        //题目共有
        ID: 0, //题目id
        QuestionType: "", //题目类型
        Answer: [], //答案
        Explain: "", //解析
        DifficultLvl: "", //难易度
        KnowledgePoints: [], //知识点
        Score: "", //分数
        Sort: "", //排序
        AnswerAreaRows: "", // 增加的高度行
        AreaHeight: "", //  整个题的高度

        //编辑题目独有
        QuestionStem: "", //题干文本.

        // 图片题目独有
        QuestionStemImage: "", //题干图片
        RegionX: this.question.RegionX,
        RegionY: this.question.RegionY,
        RegionW: this.question.RegionW,
        RegionH: this.question.RegionH,
      };
    },
    // 重置在线出题
    resetOnlineQuestion() {
      this.activeQuestionIndex = -1;
      this.initQuestion();

      // 清空主观题的正确答案编辑框
      if (this.answerUEditor && this.answerUEditor.isReady) {
        this.answerUEditor.setEnabled();
        this.answerUEditor.setContent("");
      }

      // 清空答案解析编辑框
      if (this.explainUEditor && this.explainUEditor.isReady) {
        this.explainUEditor.setEnabled();
        this.explainUEditor.setContent("");
      }
      // 清空题干编辑框
      if (this.editor) {
        this.editor.enable();
        this.editor.clear();
      }
    },

    // 在线出题保存
    saveQuestion() {
      this.btnDisable = true;
      if (this.questionsRegionChanged) {
        //检测到页面布局发生了变化且未保存，提示是否继续并保存？是：保存，否：取消
        this.$confirm("检测到页面布局发生了变化且未保存，提示是否继续并保存?", "提示", {
          confirmButtonText: "继续并保存",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            //提交任务单的修改内容
            this.saveTask(false);
            //提交题目信息
            this.submitOnlineQuestion();
          })
          .catch(() => {
            this.btnDisable = false;
            return;
          });
      } else {
        //提交题目信息
        this.submitOnlineQuestion();
      }
    },

    submitOnlineQuestion() {
      if (this.taskData.Questions.length > 19 && !this.question.ID) {
        this.$alert(`任务单最多20题.`, "提示");
        this.btnDisable = false;
        return;
      }
      if (this.question.Sort == "") {
        this.question.Sort = this.taskData.Questions.length + 1;
      }
      //题干
      //let QuestionStem = this.editorCreate.txt.html();
      let QuestionStem = this.html;
      this.question.QuestionStem = QuestionStem;

      //检测题干,独有
      if (this.htmlToText(this.question.QuestionStem) == "" || this.htmlToText(this.question.QuestionStem) == "请输入内容") {
        this.$alert(`请编辑题干.`, "提示");
        this.btnDisable = false;
        return;
      }

      if (this.taskData.IsScore == 1 && (!Number(this.question.Score) || Number(this.question.Score) < 0)) {
        this.$alert("请设置题目的分值且大于0！", "错误", { type: "error" });
        this.btnDisable = false;
        return;
      }

      if (!this.checkQuestion()) {
        this.btnDisable = false;
        return;
      }
      // 计算题目的高度
      let style = getComputedStyle(this.showQuestion);
      this.question.RegionW = Math.round((this.taskData.TrueWidth / 210) * 793.69);
      this.question.RegionH = parseFloat(style.height);

      // 答案
      if (this.question.QuestionType > 3) {
        let answer = this.answerUEditor.getContent();
        if ((this.htmlToText(answer) != "" && this.htmlToText(answer) != "请输入内容") || answer.indexOf("img") != -1) {
          answer = answer.substring(answer.indexOf('>') + 1, answer.length - 4);
        } else {
          answer = "";
        }
        this.question.Answer = answer;
      }
      //解析
      let explain = this.explainUEditor.getContent();
      if ((this.htmlToText(explain) != "" && this.htmlToText(explain) != "请输入内容") || explain.indexOf("img") != -1) {
        explain = explain.substring(explain.indexOf('>') + 1, explain.length - 4);
      } else {
        explain = "";
      }
      this.question.Explain = explain;

      let points = [];
      if (this.question.KnowledgePoints && this.question.KnowledgePoints.length > 0) {
        for (let kp of this.question.KnowledgePoints) {
          points.push(kp.PointNo);
        }
      }

      this.axios
        .post(window.url + "SaveZiZhuQuestion", {
          QuestionID: this.question.ID,
          TaskListID: this.taskData.TaskListID, //任务单id
          QuestionType: this.question.QuestionType, //题型
          QuestionStem: this.question.QuestionStem,
          QuestionStemImage: this.question.QuestionStemImage,
          Answer: this.question.QuestionType == 2 ? this.question.Answer.sort().join("") : this.question.Answer,
          Explain: this.question.Explain,
          DifficultLvl: this.question.DifficultLvl,
          RegionX: this.question.RegionX,
          RegionY: this.question.RegionY,
          RegionW: this.question.RegionW,
          RegionH: this.question.RegionH,
          KnowledgePoints: points,
          Score: this.question.Score,
          Sort: this.question.Sort,
          QuestionBankSID: this.question.SID,
        })
        .then((res) => {
          //console.log("在线出题保存", res);
          //异常处理.
          if (res.data.result !== 200) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
            this.btnDisable = false;
            return;
          }
          //获取正常数据.
          let resData = res.data.data;

          //保存成功,赋值题目的id
          if (!this.question.ID) {
            this.question.ID = resData;
            this.taskData.Questions.push(this.question);
          }
          //2,向taskData添加,且清空当前的题目, 特别注意返回的是题目的id,这个要保存的.
          this.resetOnlineQuestion();
          // 编辑器清空
          this.onlineQuestionStatus = false; //修改状态为非编辑.用于编辑状态的题目.
          this.$message({
            message: "保存成功",
            type: "success",
          });
          //3,弹出保存成功提示.
          this.btnDisable = false;
        });
    },

    // 编辑/删除/移动/取消在线出题编辑
    editOnlineQuestion(item) {
      if ((this.question.Edit || this.onlineQuestionStatus) && this.html && this.html != "<p><br></p>") {
        this.$alert("当前编辑的题目还未保存.", "提示");
        return;
      }
      console.log(item);
      this.question = item;
      this.isReviewOnline = false;
      this.question.Edit = true;
      this.answerUEditor.setEnabled();
      this.explainUEditor.setEnabled();
      this.onlineQuestionStatus = true;
      if (this.question.QuestionType > 4) {
        this.question.QuestionType = 4;
      }
      if (this.question.QuestionType === 2) {
        if (typeof this.question.Answer === "string") {
          this.question.Answer = this.question.Answer.split("");
        }
      }
      //题干加入编辑器QuestionStem
      let html = this.question.QuestionStem;
      this.editor.setHtml(html);
      //答案解析加入编辑器
      this.explainUEditor.setContent(this.question.Explain);
      // 主观题的正确答案加入编辑器
      if (this.question.QuestionType > 3) {
        this.answerUEditor.setContent(this.question.Answer);
      }
      // scroll
      let dv = document.querySelector(".editorCreate");
      dv.scrollTop = dv.scrollHeight;
    },
    //删除题目,
    delOnlineQuestion(item) {
      if ((this.question.Edit || this.onlineQuestionStatus) && this.html && this.html != "<p><br></p>") {
        this.$alert("当前编辑的题目还未保存.", "提示");
        return;
      }
      this.$confirm("此操作将删除题目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.axios.post(window.url + "DeleteZiZhuQuestion", { QuestionID: item.ID }).then((res) => {
          //异常处理.
          if (res.data.result !== 200) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
            return;
          }
          //获取正常数据.
          let resData = res.data.data;
          this.taskData.Questions = resData;
          this.resetOnlineQuestion();
          this.$message.success(res.data.message);
        });
      });
    },
    //位置移动
    moveOnlineQuestion(item, i, point) {
      if ((this.question.Edit || this.onlineQuestionStatus) && this.html && this.html != "<p><br></p>") {
        this.$alert("当前编辑的题目还未保存.", "提示");
        return;
      }
      // 保存当前item.,
      let tmp = this.taskData.Questions[i + point];
      this.taskData.Questions.splice(i + point, 1, item);
      this.taskData.Questions.splice(i, 1, tmp);
      //与后端交互,返回数据重新赋值.
      let sortStr = [];
      for (let tmp of this.taskData.Questions) {
        sortStr.push(tmp.ID);
      }
      this.axios
        .post(window.url + "SaveZiZhuQuesitonSort", {
          QuestionIDList: sortStr.join(","),
        })
        .then((res) => {
          //异常处理.
          if (res.data.result !== 200) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
            return;
          }
          //获取正常数据.
          let resData = res.data.data;
          this.taskData.Questions = resData;
          this.$message.success(res.data.message);
        });
    },
    //取消编辑
    clearOnlineEdit() {
      this.resetOnlineQuestion();

      this.onlineQuestionStatus = false;
    },
    //预览题目
    reviewQuestionItem(item, i) {
      // console.log(this.onlineQuestionStatus, this.activeQuestionIndex);
      //return;
      if (!this.onlineQuestionStatus && i !== this.activeQuestionIndex) {
        this.question = item;
        this.isReviewOnline = true;
        this.answerUEditor.setDisabled();
        this.explainUEditor.setDisabled();
        this.activeQuestionIndex = i;
        if (this.question.QuestionType === 2) {
          if (typeof this.question.Answer === "string") {
            this.question.Answer = this.question.Answer.split("");
          }
        }
        // 主观题的正确答案加入编辑器
        if (this.question.QuestionType >= 4) {
          this.question.QuestionType = 4;
          this.answerUEditor.setContent(this.question.Answer);
        }
        // console.log("预览题目", this.question);
        //答案解析加入编辑器
        this.explainUEditor.setContent(this.question.Explain);
      }
    },
    //离开时还原.
    leaveOnlineQuestion() {
      console.log("leaveOnlineQuestion");
      this.activeQuestionIndex = -1;
      let editTxt = this.html;

      if (!this.onlineQuestionStatus) {
        this.isReviewOnline = false;

        this.resetOnlineQuestion();
        this.editor.setHtml(editTxt);
        this.editor.focus();
        let ipt = this.editor.getEditableContainer();
        this.triggerEvent(ipt, "mousedown");
        ipt.focus();
      }
    },

    /*在线出题部分*/

    /*传题选题开始*/

    //点击上传按钮选择文件上传，上传题目的底图
    upImgProgress() {
      this.upIpt = false;
      if (this.question.Edit) {
        this.$alert("当前的题目还未保存.请保存后再上传", "提示");
        return;
      }
      this.question.TaskListID = this.taskData.TaskListID;
      if (!this.question.TaskListID) {
        this.$alert(`任务单还未保存,请保存后再来添加题目.`, "提示");
        return;
      }
      //根据选择,能否变换上传文件.
      this.$confirm(
        `传题选题最多支持${this.limit}页,您最多还可以上传${this.limit -
        this.paginationOpt.total}张图片, word/pdf一次只能上传一个文件,自动截取前${this.limit - this.paginationOpt.total}页.`,
        "提示",
        {
          confirmButtonText: "上传图片",
          cancelButtonText: "上传word/pdf",
          type: "warning",
          distinguishCancelAndClose: true,
        }
      )
        .then(() => {
          this.upIpt = true;
          this.upAssistImgAccess = "image/*";
          this.multiple = true;
          this.reg = /jpg|jpeg|png|bmp/gi;
          this.$nextTick(() => {
            this.upAssistImg = document.getElementById("upAssistImg");
            this.upAssistImg.click();
          });
        })
        .catch((action) => {
          // console.log("action",action);
          // return;
          if (action === "cancel") {
            // 上传word
            this.upIpt = true;
            this.upAssistImgAccess =
              "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            this.multiple = false;
            this.reg = /doc|docx|pdf/gi;
            this.$nextTick(() => {
              this.upAssistImg = document.getElementById("upAssistImg");
              // console.log(this.upAssistImg);
              this.upAssistImg.click();
            });
          }
        });
    },
    //文件选择完成后提交上传
    upImgChange(e) {
      let files = e.target.files;
      let filesNum = files.length;
      //判断图片个数.
      if (filesNum === 0) {
        return;
      }
      if (filesNum + this.taskPages.length > 8) {
        this.$alert(`最多上传${this.limit}张图片.`, "提示");
        return;
      }

      let formData = new FormData();
      let tmp = {
        TaskListID: this.question.TaskListID,
      };
      formData.append("text", JSON.stringify(tmp));
      for (let i = 0; i < filesNum; i++) {
        let file = files[i];
        let name = file.name;
        let size = file.size;
        let nameOther = name.substring(name.lastIndexOf(".") + 1).toLowerCase();
        if (!nameOther.match(this.reg)) {
          this.$alert(nameOther + "类型的文件不支持.", "提示");
          return;
        }
        if (size > 3145728) {
          this.$alert(name + "上传失败,文件最大支持3M", "提示");
          return;
        }
        formData.append("file" + i, file);
      }
      this.loading = true;
      this.axios.post(window.url + "JiaoFuZiLiaoUploadImages", formData).then((res) => {
        if (res.data.result === 200) {
          this.loading = false;
          res.data.data.forEach((item, i) => {
            this.taskPages.push(item);
          });
          this.taskData.isOnline = 2; //成功后端自动更改为2, 这里也更改为2.
          this.paginationOpt.total = this.taskPages.length;
          if (this.opt.img === "") {
            this.opt.img = this.taskPages[0].PageImage;
          }
        } else {
          this.loading = false;
          this.$alert("上传失败,请重新上传", "提示");
        }
      });
    },

    //图片.分页.
    taskPageChange(i) {
      if (this.question.Edit) {
        this.$alert("当前的题目还未保存.", "提示");
        this.paginationOpt.currentPage = this.editNowPage;
        return;
      }
      this.opt.img = this.taskPages[i - 1].PageImage;
      this.cutImgs.parentElement.scrollTop = 0;
      this.handleQuestionListChange();
    },
    //删除当前页
    delTaskPage() {
      if (this.question.Edit) {
        this.$alert("当前的题目还未保存.", "提示");
        return;
      }
      // 根据当前的opt.img找出i
      if (this.taskPages.length <= 0) {
        this.$alert("您还没有上传教辅资料图片", "提示");
        return;
      }
      // 确认删除提示
      if (this.opt.img) {
        this.$confirm("此操作将删除该页以及页中的题目, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            //删除当前页
            this.axios
              .post(window.url + "DeleteTaskPage ", {
                TaskPageID:
                  this.taskPages[this.paginationOpt.currentPage - 1].ID ||
                  this.taskPages[this.paginationOpt.currentPage - 1].PageID,
              })
              .then((res) => {
                //异常处理.
                if (res.data.result !== 200) {
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                  return;
                }
                //重新获取刷新数据.
                this.axios({
                  method: "GET",
                  url: window.url + "GetJiaoFuZiLiaoForEdit2",
                  params: {
                    TaskListID: this.taskData.TaskListID,
                    TeachingPlanID: this.taskData.TeachingPlanID,
                  },
                }).then((res) => {
                  //异常处理.
                  if (res.data.result !== 200) {
                    return;
                  }
                  let resData = res.data.data;
                  this.taskPages.splice(0);
                  resData["taskPagesAndQuestions"].forEach((item, i, arr) => {
                    this.taskPages[i] = item;
                  });
                  //把所有页的题目组合到一个数组中,并按题号排序
                  this.taskData.Questions = [];
                  this.taskPages.forEach((item) => {
                    let ql = item.Questions;
                    this.taskData.Questions = this.taskData.Questions.concat(ql);
                  });
                  this.taskData.Questions.sort((a, b) => {
                    return a.sort - b.sort;
                  });

                  if (this.taskPages.length < this.paginationOpt.currentPage) {
                    //删除的是最后一页
                    if (this.taskPages.length > 0) {
                      //未全删光
                      this.opt.img = this.taskPages[0].PageImage;
                      this.$refs.crop.reload(); //框题区域重载
                    } else {
                      //全删光了
                      this.opt.img = "";
                    }
                    this.paginationOpt.currentPage = 1;
                  } else {
                    this.opt.img = this.taskPages[this.paginationOpt.currentPage - 1].PageImage;
                    this.$refs.crop.reload(); //框题区域重载
                  }
                  this.paginationOpt.total = this.taskPages.length;
                  // console.log(this.paginationOpt);
                });
                this.$message.success("删除页成功");
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },

    //保存图和裁题
    saveImgQuestion() {
      this.btnDisable = true;
      if (this.questionsRegionChanged) {
        //检测到页面布局发生了变化且未保存，提示是否继续并保存？是：保存，否：取消
        this.$confirm("检测到页面布局发生了变化且未保存，提示是否继续并保存?", "提示", {
          confirmButtonText: "继续并保存",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.saveTask(false);
            this.submitImgQuestion();
          })
          .catch(() => {
            this.btnDisable = false;
            return;
          });
      } else {
        this.submitImgQuestion();
      }
    },

    /*提交圈题题目信息*/
    submitImgQuestion() {
      //检测当前是否有图片
      if (!this.opt.img) {
        this.$alert("还未上传教辅图片", "提示");
        this.btnDisable = false;
        return;
      }
      if (!this.checkQuestion()) {
        this.btnDisable = false;
        return;
      }
      if (!this.question.RegionW || !this.question.RegionH || !this.question.RegionW || !this.question.RegionH) {
        this.btnDisable = false;
        this.$alert("请移动裁题框,截取题目", "提示");
        return;
      }
      if (this.taskData.IsScore == 1 && (!Number(this.question.Score) || Number(this.question.Score) < 0)) {
        this.$alert("请设置题目的分值且大于0！", "错误", { type: "error" });
        this.btnDisable = false;
        return;
      }
      /* --------检测框题区域是否异常   start ----------*/
      //作业真正的宽高，单位毫米mm
      let pageW =
        this.taskData.TrueWidth > 0
          ? this.taskData.TrueWidth
          : this.taskPages.length > 0 && this.taskPages[this.paginationOpt.currentPage - 1].PageWidth > 0
            ? this.taskPages[this.paginationOpt.currentPage - 1].PageWidth
            : 210;
      let pageH =
        this.taskData.TrueHeight > 0
          ? this.taskData.TrueHeight
          : this.taskPages.length > 0 && this.taskPages[this.paginationOpt.currentPage - 1].PageHeight > 0
            ? this.taskPages[this.paginationOpt.currentPage - 1].PageHeight
            : 297;
      // 毫米mm换算成像素px
      let w = Math.round((pageW / 210) * 793.69 * 100) / 100;
      let h = Math.round((pageH / 210) * 793.69 * 100) / 100;
      this.question.RegionX = Math.floor(this.question.RegionX * 100) / 100;
      this.question.RegionY = Math.floor(this.question.RegionY * 100) / 100;
      this.question.RegionW = Math.floor(this.question.RegionW);
      this.question.RegionH = Math.floor(this.question.RegionH);
      if (this.question.RegionX < 0 || this.question.RegionY < 0 || this.question.RegionY > h || this.question.RegionX > w || this.question.RegionW + this.question.RegionX > w || this.question.RegionH + this.question.RegionY > h) {
        this.$alert("框题区域超出了范围，将自动校正，请调整后再保存！", "错误", { type: "error" });
        // 框起始位置x超出了左边缘、右边缘，调整为距离左边缘20的位置
        if (this.question.RegionX < 0 || this.question.RegionX > w) {
          this.question.RegionX = 20;
          this.opt.setOffsetX = this.question.RegionX;
        }

        // 框起始位置y坐标超出了上边缘、下边缘，调整为距离上边缘20的位置
        if (this.question.RegionY < 0 || this.question.RegionY > h) {
          this.question.RegionY = 20;
          this.opt.setOffsetY = this.question.RegionY;
        }

        // 框超出了右边缘，调整为距离右边缘20的位置
        if (this.question.RegionW + this.question.RegionX > w) {
          this.question.RegionW = w - this.question.RegionX - 20;
          this.opt.setCorpW = this.question.RegionW;
        }
        // 框超出了下边缘，调整为距离下边缘20的位置
        if (this.question.RegionH + this.question.RegionY > h) {
          this.question.RegionH = h - this.question.RegionY - 20;
          this.opt.setCorpH = this.question.RegionH;
        }
        this.btnDisable = false;
        return;
      }
      if (this.question.RegionW < 40 || this.question.RegionH < 20) {
        this.$alert("框题区域过小，将自动校正，请调整后再保存！", "错误", { type: "error" });
        // 框宽度过小，调到最小框题50
        if (this.question.RegionW < 50) {
          this.question.RegionW = 50;
          this.opt.setCorpW = this.question.RegionW;
        }
        // 高度过下，调到最小高度30
        if (this.question.RegionH < 30) {
          this.question.RegionH = 30;
          this.opt.setCorpH = this.question.RegionH;
        }
        this.btnDisable = false;
        return;
      }
      /* --------检测框题区域是否异常   end ----------*/
      // 答案
      if (this.question.QuestionType > 3) {
        let answer = this.answerUEditor.getContent();
        if ((this.htmlToText(answer) != "" && this.htmlToText(answer) != "请输入内容") || answer.indexOf("img") != -1) {
          answer = answer.substring(answer.indexOf('>') + 1, answer.length - 4);
        } else {
          answer = "";
        }
        this.question.Answer = answer;
      }
      //解析
      let explain = this.explainUEditor.getContent();
      if ((this.htmlToText(explain) != "" && this.htmlToText(explain) != "请输入内容") || explain.indexOf("img") != -1) {
        explain = explain.substring(explain.indexOf('>') + 1, explain.length - 4);
      } else {
        explain = "";
      }
      this.question.Explain = explain;

      let points = [];
      if (this.question.KnowledgePoints && this.question.KnowledgePoints.length > 0) {
        for (let kp of this.question.KnowledgePoints) {
          points.push(kp.PointNo);
        }
      }
      //截图保存题目
      this.$refs.crop.getCropData((imgData) => {
        let imgQuestion = new FormData();
        imgQuestion.append("Files", this.dataURLtoFile(imgData));
        //console.log("当前的页", this.taskPages);
        //console.log("当前的页列表:", this.taskPages);
        imgQuestion.append(
          "text",
          JSON.stringify({
            ExercisePageId: this.taskPages[this.paginationOpt.currentPage - 1].ExercisePageId
              ? this.taskPages[this.paginationOpt.currentPage - 1].ExercisePageId
              : 0,
            TaskListID: this.taskData.TaskListID, //任务单id
            TaskPageID:
              this.taskPages[this.paginationOpt.currentPage - 1].ID ||
              this.taskPages[this.paginationOpt.currentPage - 1].PageID,
            QuestionID: this.question.ID,
            QuestionType: this.question.QuestionType, //题型
            Answer: this.question.QuestionType == 2 ? this.question.Answer.sort().join("") : this.question.Answer, // 正确答案
            Explain: this.question.Explain,
            DifficultLvl: this.question.DifficultLvl,
            RegionX: this.question.RegionX,
            RegionY: this.question.RegionY,
            RegionW: this.question.RegionW,
            RegionH: this.question.RegionH,
            KnowledgePoints: points,
            Score: this.question.Score,
            QuestionBankSID: this.question.SID,
            QuestionNum: this.question.QuestionNum
          })
        );
        // console.log("要保存的题目信息", this.question);
        this.axios
          .post(window.url + "SaveTaskQuestion", imgQuestion, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((res) => {
            //console.log("保存截图题目返回的数据", res);
            //异常处理.
            if (res.data.result !== 200) {
              this.$message({
                message: res.data.message,
                type: "error",
              });
              this.btnDisable = false;
              return;
            }
            //重新获取数据
            this.getJiaoFuZiliaoForEdit2();
            /* //获取正常数据.
            this.question.ID = res.data.data.questionID;
            this.question.QuestionStemImage = res.data.data.path;
            if (this.question.Sort === "") {
              this.question.Sort = res.data.data.sort;
            }
            delete this.question.Edit;
            this.taskPages[this.paginationOpt.currentPage - 1].Questions.splice(
              this.question.Sort - 1,
              1,
              this.question
            );

            //把所有页的题目组合到一个数组中,并按题号排序
            this.taskData.Questions = [];
            //组合题目.
            this.taskPages.forEach((item) => {
              let ql = item.Questions;
              this.taskData.Questions = this.taskData.Questions.concat(ql);
            });
            this.taskData.Questions.sort((a, b) => {
              return a.sort - b.sort;
            }); */

            const num = this.question.QuestionNum
            this.initQuestion();
            if (!isNaN(Number(num))) {
              this.$set(this.question, 'QuestionNum', String(Number(num) + 1));
            } else {
              // 保留原值，不赋空
              this.$set(this.question, 'QuestionNum', '');
            }

            //生成框.
            //console.log(this.taskPages[this.paginationOpt.currentPage - 1]);
            this.question.RegionY = this.question.RegionY + this.question.RegionH + 20;
            this.opt.setOffsetY = this.question.RegionY;
            //默认下一题的框跟上一题一样，本页剩余高度如果不足，直接设为初始高度50
            if (this.question.RegionH > h - this.question.RegionY) {
              this.question.RegionH = 50;
              this.opt.setCorpH = this.question.RegionH;
              if (this.question.RegionY + 50 > h) {
                this.question.RegionY = h - 70;
                this.opt.setOffsetY = this.question.RegionY;
              }
            }
            //重置编辑器.
            this.html = "";
            this.answerUEditor.setContent("");
            this.explainUEditor.setContent("");

            //保存成功提示
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.btnDisable = false;
          });
      });
    },

    //编辑/删除图片裁题.
    selectQuestion(i, isEditor) {
      console.log("selectQuestion", i, isEditor);
      if (this.question.Edit) {
        this.$alert("当前的题目还未保存.", "提示");
        return;
      }
      //编辑
      if (isEditor) {
        this.question = this.taskPages[this.paginationOpt.currentPage - 1].Questions[i];
        this.question.DifficultLvl = this.question.DifficultLvl === 0 ? "" : this.question.DifficultLvl;
        this.isReviewImgQuestion = false;
        this.answerUEditor.setEnabled();
        this.explainUEditor.setEnabled();
        if (this.question.QuestionType === 2) {
          if (typeof this.question.Answer === "string") {
            this.question.Answer = this.question.Answer.split("");
          }
        }
        this.opt.setCorpW = parseFloat(this.question.RegionW);
        this.opt.setCorpH = parseFloat(this.question.RegionH);
        this.opt.setOffsetX = parseFloat(this.question.RegionX);
        this.opt.setOffsetY = parseFloat(this.question.RegionY);
        // page页中删除当前的题目
        // this.taskPages[this.paginationOpt.currentPage - 1].Questions.splice(i, 1);
        //题目中添加编辑状态标识
        this.question.Edit = true;
        this.editNowPage = this.paginationOpt.currentPage;
      }
      //删除.
      else {
        this.$confirm("此操作将删除题目, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.axios
            .post(window.url + "DeleteTaskQuestion ", {
              QuestionID: this.taskPages[this.paginationOpt.currentPage - 1].Questions[i].ID,
            })
            .then((res) => {
              //异常处理.
              if (res.data.result !== 200) {
                this.$message({
                  message: res.data.message,
                  type: "error",
                });
                return;
              }
              this.$message.success("题目删除成功");
              //重新获取数据
              this.getJiaoFuZiliaoForEdit2();
            });
        });
      }
    },
    reviewImgQuestion(i, item) {
      console.log("reviewImgQuestion", i);
      this.activeQuestionIndex = i;
      // console.log("选择题目:", item, this.question.Edit, this.isReviewImgQuestion);
      if (!this.question.Edit) {
        if (i != -1) {
          this.question = item;
          this.question.DifficultLvl = this.question.DifficultLvl === 0 ? "" : this.question.DifficultLvl;
          if (this.question.QuestionType === 2) {
            if (typeof this.question.Answer === "string") {
              this.question.Answer = this.question.Answer.split("");
            }
          }
          if (this.question.QuestionType > 3) {
            this.answerUEditor.setContent(this.question.Answer);
          }
          this.explainUEditor.setContent(this.question.Explain);
          this.isReviewImgQuestion = true;
          this.answerUEditor.setDisabled();
          this.explainUEditor.setDisabled();
        } else {
          this.initQuestion();
        }
      }
    },
    dragBoxClick() {
      // console.log(this.taskData);
      if (this.isReviewImgQuestion && !this.question.Edit) {
        this.initQuestion();
        this.html = "";
        this.answerUEditor.setContent("");
        this.explainUEditor.setContent("");
        this.isReviewImgQuestion = false;
        this.answerUEditor.setEnabled();
        this.explainUEditor.setEnabled();
        this.question.RegionX = Math.floor(this.$refs.crop.getCropAxis().x1 * 100) / 100;
        this.question.RegionY = Math.floor(this.$refs.crop.getCropAxis().y1 * 100) / 100;
        this.question.RegionW = Math.round(this.$refs.crop.cropW);
        this.question.RegionH = Math.round(this.$refs.crop.cropH);
      }
    },
    realTime(e) {
      if (!this.isReviewImgQuestion) {
        this.question.RegionX = Math.floor(this.$refs.crop.getCropAxis().x1 * 100) / 100;
        this.question.RegionY = Math.floor(this.$refs.crop.getCropAxis().y1 * 100) / 100;
        this.question.RegionW = Math.round(this.$refs.crop.cropW);
        this.question.RegionH = Math.round(this.$refs.crop.cropH);
      }
    },

    //题号切换
    numChange(e) {
      //console.log(this.taskData,this.taskPages,this.chapter);
      let that = this;
      this.axios
        .post(window.url + "SaveQuestionNum ", {
          questionid: e.nowQue.ID,
          tasklistid: e.nowQue.TaskListID,
          num: e.changeSort,
        })
        .then((res) => {
          if (res.data.result !== 200) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
            return;
          }
          //重新获取数据
          this.getJiaoFuZiliaoForEdit2();
          this.question.QuestionNum = JSON.parse(JSON.stringify(e.changeSort))
        });
    },
    getJiaoFuZiliaoForEdit2() {
      this.axios({
        method: "GET",
        url: window.url + "GetJiaoFuZiLiaoForEdit2",
        params: {
          TaskListID: this.taskData.TaskListID,
          TeachingPlanID: this.taskData.TeachingPlanID,
        },
      }).then((res) => {
        //异常处理.
        if (res.data.result !== 200) {
          this.$message({
            message: res.data.message,
            type: "error",
          });
          return;
        }
        console.log("新数据:", res);
        //获取正常数据.
        let resData = res.data.data;
        this.taskData = resData["taskList"];
        this.taskPages = resData["taskPagesAndQuestions"];
        /* this.taskPages.splice(0);
        resData["taskPagesAndQuestions"].forEach((item, i, arr) => {
          this.taskPages[i] = item;
        }); */
        //把所有页的题目组合到一个数组中,并按题号排序
        this.taskData.Questions = [];
        this.taskPages.forEach((item) => {
          let ql = item.Questions;
          this.taskData.Questions = this.taskData.Questions.concat(ql);
        });
        this.taskData.Questions.sort((a, b) => {
          return a.sort - b.sort;
        });
      });
    },
    //选择教辅资料
    teachingAuxiliary() {
      //验证当前的题目状态.
      if (this.question.Edit) {
        this.$alert("当前的题目还未保存.请保存后再上传", "提示");
        return;
      }
      this.question.TaskListID = this.taskData.TaskListID;
      if (!this.question.TaskListID) {
        this.$alert(`任务单还未保存,请保存后再来添加题目.`, "提示");
        return;
      }
      this.teachingAuxiliaryDialog = true;
      this.getExerciseBookList();
      //console.log("选择教辅资料!!");
    },
    /*传题选题结束*/
    reviewQuestionScroll(e) {
      this.newTop = parseFloat(e.target.scrollTop);
    },
    ///搜索教辅练习册
    getExerciseBookList() {
      this.exerciseBookCondition.pageindex = this.exerPage.currentPage;
      this.exerciseBookCondition.scopeLevel = this.scopeLevelData[this.selScopeLevel].value;
      this.exerciseBookCondition.gradeName = this.schoolGradeData[this.selSchoolGrade];
      this.axios({
        method: "GET",
        url: window.hosturl + "/rest/ExerciseBook/GetExerciseBookList",
        params: this.exerciseBookCondition,
      }).then((res) => {
        //console.log("获取教辅练习册", res);
        if (res.data.result !== 200) {
          this.$message.error("获取教辅练习册失败,联系管理员.");
          return;
        }
        this.exerData = res.data.data.datalist;
        this.exerPage.total = res.data.data.totalSize;
      });
    },
    addExerciseBook(e) {
      //组卷出题，跳转到组卷页面
      let baseUrl;
      let localHref = location.href.indexOf("localhost");
      if (localHref < 0) {
        if (window.url.indexOf("test") > -1) {
          baseUrl = "https://hwtest.jianxiangjiaoyu.com";
        } else {
          baseUrl = "https://hw.jianxiangjiaoyu.com";
        }
      } else {
        baseUrl = "http://localhost:8849";
      }
      let redirect = "/exerciseDetail?exerciseId=0%26pageType=edit%26fromUrl=task";
      let url = `${baseUrl}#/aLogin?un=${sessionStorage["un"]}&md5=${sessionStorage["Md5"]}&redirect=${redirect}`;
      window.open(url, "_bank");
      // console.log('addExerciseBook', e);
      // this.$router.push({name: 'ExerDetail', query: {exerciseId: 0, pageType: 'edit'}});
    },
    //选择练习册
    selExerShow(e) {
      //console.log("选择练习册",e);
      this.showPage = true;
      this.pagesCondition.exerciseId = e.Id;
      this.selExerPages();
      this.getPagesList();
    },
    deleteBook(index) {
      this.exerData.splice(index, 1);
    },
    //搜索册中页.
    selExerPages() {
      this.axios({
        method: "GET",
        url: window.hosturl + "/rest/ExerciseBook/GetExerciseBookPages",
        params: this.pagesCondition,
      }).then((res) => {
        if (res.data.result !== 200) {
          this.$message.error("获取练习页失败.");
          return;
        }
        this.pagesData = res.data.data;
        this.pagesData.datalist = this.pagesData.datalist.map((item) => {
          item.chk = false;
          this.selPages.forEach((val) => {
            if (item.Id === val) {
              item.chk = true;
            }
          });
          return item;
        });
        this.pagesPage.total = this.pagesData.totalSize;
      });
    },
    //搜索所有页
    getPagesList() {
      this.axios({
        method: "GET",
        url: window.hosturl + "/rest/ExerciseBook/GetPagesList",
        params: { exerciseBookId: this.pagesCondition.exerciseId },
      }).then((res) => {
        if (res.data.result !== 200) {
          this.$message.error("获取所有练习页失败.");
          return;
        }
        this.pagesList = res.data.data;
      });
    },
    //练习册分页
    exerPageChange(e) {
      // console.log("练习册分页", e);
      this.exerciseBookCondition.pageindex = e;
      this.getExerciseBookList();
    },
    //练习页分页.
    pagesPageChange(e) {
      // console.log("练习页分页", e);
      this.pagesCondition.pageindex = e;
      this.selExerPages();
    },
    //选择页变化.
    selPagesChange(e) {
      if (this.selPages.length + this.taskPages.length > this.limit) {
        this.selPages.pop();
        // console.log(this.$refs);
        this.$refs.selPages.blur();
        this.$alert(`一个任务单最多${this.limit}页`, "提示");
        return;
      }
      //console.log(e,this.selPages,this.pagesData);
      this.pagesData.datalist = this.pagesData.datalist.map((item) => {
        item.chk = false;
        //console.log(this.selPages);
        this.selPages.forEach((val) => {
          if (item.Id === val) {
            item.chk = true;
          }
        });
        return item;
      });
      // console.log(this.pagesData.datalist);
    },
    checkBoxPage(e) {
      // console.log(e);
      // console.log("当前的页面", this.taskPages.length, this.selPages.length);

      if (e.checked && this.selPages.length + this.taskPages.length == this.limit) {
        this.$alert(`一个任务单最多${this.limit}页`, "提示");
        return;
      }
      this.pagesData.datalist = this.pagesData.datalist.map((item) => {
        if (item.Id === e.item.Id) {
          item.chk = e.checked;
        }
        return item;
      });
      //判断是否有该页码,
      // console.log(e);
      if (e.checked) {
        this.selPages.push(e.item.Id);
      } else {
        this.selPages = this.selPages.filter((val) => {
          return val !== e.item.Id;
        });
      }
    },
    /**
     * 设置分值
     */
    handleScoreClick() {
      this.scoreDialogShow = true;
      this.questionScores = [];
      this.totalScore = 0;
      for (let j = 0; j < this.taskData.Questions.length; j++) {
        let questionScore = {};
        questionScore.questionId = this.taskData.Questions[j].ID;
        let score = Number(this.taskData.Questions[j].Score);
        if (score && score > 0) {
          questionScore.score = score;
          this.totalScore += score;
        } else {
          questionScore.score = "";
        }
        this.questionScores.push(questionScore);
      }
    },
    handleScoreClear() {
      for (let i = 0; i < this.questionScores.length; i++) {
        this.questionScores[i].score = "";
      }
      this.totalScore = 0;
    },
    /**
     * 确认分值设置
     */
    handleScoreConfirm() {
      for (let j = 0; j < this.questionScores.length; j++) {
        let questionScore = this.questionScores[j];
        if (!Number(questionScore.score) || Number(questionScore.score) < 0) {
          this.$alert("请设置每一题的分值，分值不可小于0！！！");
          return;
        }
      }
      //填充保存分值的参数
      let formData = {};
      formData.taskId = this.taskData.TaskListID;
      formData.data = this.questionScores;
      this.axios
        .post(window.url + "SaveScore ", formData)
        .then((res) => {
          if (res.data.result == 200) {
            this.$message.success("分值设置提交成功");
            this.scoreDialogShow = false;
            for (let i = 0; i < this.questionScores.length; i++) {
              let questionScore = this.questionScores[i];
              let score = Number(questionScore.score);
              this.taskData.Questions[i].Score = score;
            }
          } else {
            this.$message.error("分值设置提交失败");
          }
        })
        .catch((err) => {
          this.$message.error("分值设置提交失败");
        });
    },
    /**
     * 设置分值取消关闭对话框
     */
    handleScoreDialogClose() {
      this.scoreDialogShow = false;
      this.questionScores = [];
      this.totalScore = 0;
    },
    /**
     * 题目单独设置分值改变
     * @param e
     * @param typeIndex
     * @param questionIndex
     */
    questionScoreChanged(e, typeIndex, questionIndex) {
      let totalScore = 0;
      for (let qscore of this.questionScores) {
        let s = Number(qscore.score) ? Number(qscore.score) : 0;
        totalScore += s;
      }
      this.totalScore = totalScore;
    },
    //重置教辅资料
    resetTeachingAuxiliary() {
      //console.log("关了吗?");
      this.exerData = [];
      this.pagesData = {
        currentPage: 0,
        datalist: [],
        pageSize: 12,
        totalSize: 200,
      };
      this.showPage = false;
      this.selPages = [];
      this.selScopeLevel = 0;
      this.selSchoolGrade = 0;
      this.exerPage = {
        currentPage: 1,
        pageSize: 12, //每页多少行
        total: 15, //总行数
        pageCounter: 11, //折叠数,只能为单数....神奇啊
      };
      this.pagesCondition = {
        pageindex: 0,
        pageSize: 12,
        exerciseId: "",
      };
    },
    //确定根据页创建
    createTeachingAuxiliary() {
      if (this.selPages.length === 0) {
        this.$alert(`您还未选择练习页`, "提示");
        return;
      }
      let tmp = {
        pageList: this.selPages.join(),
        taskId: this.question.TaskListID,
      };
      this.axios.post(window.hosturl + "/rest/ExerciseBook/SaveHomeworkPagesForExerciseBook ", tmp).then((res) => {
        if (res.data.result === 200) {
          res.data.data.forEach((item, i) => {
            let page = item;
            page.Questions = item.Questions;
            this.taskPages.push(page);
            this.taskData.Questions = this.taskData.Questions.concat(item.Questions);
          });
          // console.log(this.taskData);
          // console.log(this.taskPages);
          this.paginationOpt.total = this.taskPages.length;
          if (this.opt.img === "") {
            this.opt.img = this.taskPages[0].PageImage;
          }
          this.teachingAuxiliaryDialog = false;
          //console.log('上传完成后的图片列表:', this.upAssistImg);
        } else {
          this.$message.error("选择失败,请重新尝试");
        }
      });
    },

    //打印任务单,为了保证一致, 截图打印.
    printTask() {
      if (this.question.Edit) {
        this.$alert("当前的题目还未保存.", "提示");
        return;
      }
      //弹打印提示对话框
      let sizeType = this.SizeTypes[this.taskData.SizeType - 1].name;
      if (this.taskData.SizeType > 1) {
        sizeType += "(" + this.taskData.TrueWidth + ", " + this.taskData.TrueHeight + ")";
      }

      if (this.isEditQuestion) {
        let nowPage = 0;
        let htmlDocument = `<!DOCTYPE html><html lang="en"><head>
              <meta charset="UTF-8">
              <title>${this.chapter}——任务单</title>
              <style>
                  @page{
                  margin:0;
                  }
                  @page print{
                  margin:0;
                  margin-top: 0;
                  }
                  html, body {
                      padding:0;
                      font-size: 10.5pt;
                      margin:0;
                      color: #000;
                      -webkit-font-smoothing: antialiased;
                       font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
                  }
                  font[size="7"] {
                    font-size: 26pt;
                  }
                  font[size="6"] {
                    font-size: 22pt;
                  }
                  font[size="5"] {
                    font-size: 18pt;
                  }
                  font[size="4"] {
                    font-size: 16pt;
                  }
                  font[size="3"] {
                    font-size: 14pt;
                  }
                  font[size="2"] {
                    font-size:12pt;
                  }
                  font[size="1"] {
                    font-size: 10.5pt;
                  }
                  .w-e-text img:hover{
                  box-shadow: none;
                  }
                  .w-e-text img{
                  vertical-align: top;
                  }
                  .w-e-text-container .w-e-text p {
                    font-size: 10.5pt !important;
                    margin: 10px 0;
                    line-height: 1.5;
                    word-break:normal;
                  }
                  .w-e-text-container p strong {
                    font-weight:600;
                  }
              </style>
              <script src="./js/wangEditor.min.js"><\/script>
          </head>
          <body>
          `;

        for (let i = 0; i < this.taskData.Questions.length; i++) {
          let question = this.taskData.Questions[i];
          //如果页码与题目不一样时.创建页码
          if (i == 0 || this.questionPageCount(i)) {
            //1.1, 如果是第一次 .则不加table结尾, 否则添加table结尾
            if (i !== 0) {
              htmlDocument += `</div></td></tr></table>`;
            }
            //1.2,无论是否第一次都要加table开始.
            htmlDocument += `<table border="0" cellpadding="0" cellspacing="0"  style="border:none;page-break-after:always; box-sizing:border-box; width:${this.taskData.TrueWidth
              }mm;height:${this.taskData.TrueHeight - 1}mm;padding:${this.taskData.PaddingWidth
              }mm;" ><tr><td style="vertical-align: baseline;border:none;">`;

            htmlDocument += `<div  class="w-e-text-container" style="width: ${this.taskData.TrueWidth -
              this.taskData.PaddingWidth * 2}mm;max-height: ${this.taskData.TrueHeight -
              this.taskData.PaddingWidth * 2 -
              1}mm;max-width:${this.taskData.TrueWidth - this.taskData.PaddingWidth * 2}mm;overflow: hidden">
                            <div  class="w-e-text" style="padding:0;overflow: hidden;word-break:normal; font-size: 10.5pt;">
                                ${question.QuestionStem}
                            </div>`;
            //1.3 加完之的一, 修改当前的page页.
            nowPage = question.PageNum;
            continue;
          }
          //2.0 如果相同, 直接添加题目.
          htmlDocument += `<div  class="w-e-text " style="padding:0;overflow: hidden;word-break:normal; font-size: 10.5pt;">
                                ${question.QuestionStem}
                               </div>`;
        }
        ///3.1, 最后一个Table补全.
        htmlDocument += "</td></tr></table></body></html>";
        //console.log(htmlDocument);
        //3.1 ,添加完题目后直接打印.

        let newWin = window.open("", "print");
        newWin.document.write(htmlDocument);
        newWin.document.close();
        setTimeout(function () {
          newWin.alert("请选择" + sizeType + "纸张，并选择无边距打印");
          newWin.print();
          setTimeout(function () {
            newWin.close();
          }, 100);
        }, 500);

        /*})*/
      } else {
        let htmlStr = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>${this.chapter
          }</title><style>@page{  margin:0; } @page print{  margin:0; }html, body {padding:0; margin:0; color: #000;-webkit-font-smoothing: antialiased;font-family: 'Avenir', Helvetica, Arial, sans-serif;}</style></head><body>`;
        //2 生成中间html
        for (let i = 0; i < this.taskPages.length; i++) {
          htmlStr += `<table border="0" cellpadding="0" cellspacing="0"  style="page-break-after:always;width:${this.taskData.TrueWidth > 0 ? this.taskData.TrueWidth : this.taskPages[i].PageWidth
            }mm;height:${this.taskData.TrueHeight > 0 ? this.taskData.TrueHeight : this.taskPages[i].PageHeight
            }mm;text-align: left" ><tr><td style="vertical-align: top;">`;
          htmlStr += `<img src="${this.taskPages[i].PageImage}" style="max-width:${this.taskData.TrueWidth > 0 ? this.taskData.TrueWidth : this.taskPages[i].PageWidth
            }mm;max-height: ${this.taskData.TrueHeight > 0 ? this.taskData.TrueHeight : this.taskPages[i].PageHeight
            }mm;display: block;" />`;
          htmlStr += `</td></tr></table>`;
        }
        //3 生成结束组成完成html
        htmlStr += `</body></html>`;
        let newWin = window.open("", "print");
        newWin.document.write(htmlStr);
        newWin.document.close();
        setTimeout(function () {
          newWin.alert("请选择" + sizeType + "纸张，并选择无边距打印");
          newWin.print();
          setTimeout(function () {
            newWin.close();
          }, 100);
        }, 500);
      }
    },
    //根据任务单,导出为pdf.
    async downloadTask() {
      if (this.question.Edit) {
        this.$alert("当前的题目还未保存.", "提示");
        return;
      }
      let doc = new jsPDF("p", "mm", this.taskData.TrueWidth == 176 ? "b5" : "a4");
      const options = {
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        scale: 4,
        dpi: window.devicePixelRatio * 4,
      };
      const loading = this.$loading({
        lock: true,
        text: "导出中……",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      //生成图片添加到imgs中
      let question2ImgForPrint = document.getElementById("question2ImgForPrint");
      if (this.isEditQuestion) {
        let questionsPrint = document.getElementById("questionsPrint").querySelectorAll(".question-item");

        //遍历, 并找出节点.
        //console.log("当前的题.", questionsPrint);
        let splitPage = [];
        for (let i = 0; i < questionsPrint.length; i++) {
          let que = questionsPrint[i];
          if (que.querySelector(".splitPage")) {
            splitPage.push(i);
          }
        }
        splitPage.push(questionsPrint.length);
        //根据分页内容..组成新的DOM
        let pt2Html = "";
        for (let i = 0; i < splitPage.length; i++) {
          pt2Html += `<div id="questionsPrint${i}" class="Questions questionsPrint w-e-text-container">`;
          pt2Html += `<div style="font-size: 10.5pt;height:${this.taskData.PaddingWidth}mm;line-height:${this.taskData.PaddingWidth
            }mm;font-weight:normal;color:#000;text-align: center;width:100%;font-family: SimSun,'Helvetica Neue', Helvetica, Arial, sans-serif;z-index: 9">${this.chapter
            }</div>`;
          if (i === 0) {
            for (let j = 0; j < splitPage[i]; j++) {
              pt2Html += questionsPrint[j].outerHTML;
            }
          } else {
            for (let j = splitPage[i - 1]; j < splitPage[i]; j++) {
              let spPage = questionsPrint[j].querySelector(".splitPage");
              if (spPage) {
                let node = questionsPrint[j].outerHTML;
                var pattern = /<div[^>]* class="splitPage"><\/div>/gi;
                var arr = node.split(pattern);
                pt2Html += arr.join("");
              } else {
                pt2Html += questionsPrint[j].outerHTML;
              }
            }
          }
          pt2Html += "</div>";
        }
        question2ImgForPrint.innerHTML = pt2Html;

        for (let i = 0; i < splitPage.length; i++) {
          let quetoImg = document.getElementById("questionsPrint" + i);
          let w = this.taskData.SizeType > 1 ? this.taskData.TrueWidth : this.taskPages[i].PageWidth;
          let h = this.taskData.SizeType > 1 ? this.taskData.TrueHeight : this.taskPages[i].PageHeight;
          await new html2canvas(quetoImg, options).then((canvas) => {
            let dataBase64 = canvas.toDataURL("image/jpeg", 1.0);
            if (i === splitPage.length - 1) {
              doc.addImage(dataBase64, "jpeg", 0, 0, w, h);
              doc.save(this.taskData.TaskName + ".pdf");
              loading.close();
            }
            doc.addImage(dataBase64, "jpeg", 0, 0, w, h);
            doc.addPage();
          });
        }
      } else {
        //多张图片导出为pdf
        question2ImgForPrint.innerHTML = "";
        for (let i = 0; i < this.taskPages.length; i++) {
          let pageHtml = `<table border="0" cellpadding="0" cellspacing="0"  style="page-break-after:always;width:${this.taskData.TrueWidth > 0 ? this.taskData.TrueWidth : this.taskPages[i].PageWidth
            }mm;height:${this.taskData.TrueHeight > 0 ? this.taskData.TrueHeight : this.taskPages[i].PageHeight
            }mm;text-align: left" ><tr><td style="vertical-align: top;">`;
          pageHtml += `<img src="${this.taskPages[i].PageImage}" style="max-width: ${this.taskData.TrueWidth > 0 ? this.taskData.TrueWidth : this.taskPages[i].PageWidth
            }mm;max-height: ${this.taskData.TrueHeight > 0 ? this.taskData.TrueHeight : this.taskPages[i].PageHeight
            }mm;display: block;" />`;
          pageHtml += `</td></tr></table>`;
          question2ImgForPrint.innerHTML += pageHtml;
        }
        let imagePages = question2ImgForPrint.querySelectorAll("table");

        for (let i = 0; i < imagePages.length; i++) {
          let quetoImg = imagePages[i];
          let w = this.taskData.TrueWidth > 0 ? this.taskData.TrueWidth : this.taskPages[i].PageWidth;
          let h = this.taskData.TrueHeight > 0 ? this.taskData.TrueHeight : this.taskPages[i].PageHeight;
          await new html2canvas(quetoImg, options).then((canvas) => {
            let dataBase64 = canvas.toDataURL("image/jpeg", 1.0);
            if (i === imagePages.length - 1) {
              doc.addImage(dataBase64, "jpeg", 0, 0, w, h);
              doc.save(this.taskData.TaskName + ".pdf");
              loading.close();
            }
            doc.addImage(dataBase64, "jpeg", 0, 0, w, h);
            doc.addPage();
          });
        }
      }
    },
    /* 知识点选择element-tree子组件选完知识点后更新数据 */
    pointsChanged(points) {
      console.log("pointsChanged：", points);
      this.question.KnowledgePoints = points;
    },
    /* 搜题/相似题相关 start------------------ */
    //打开搜题窗口
    openSearch(question) {
      /* console.log("关闭自动搜题：", this.autoSearchClosed);
      console.log("任务单信息：", this.taskData);
       */

      if (!question) {
        question = this.question;
      }
      console.log("要搜题信息：", question);
      if (
        this.taskData.isOnline == 1 &&
        question.QuestionStem == "" &&
        (this.html == "" || this.html.trim() == "<p><br></p>")
      ) {
        // 题目题干内容为空：编辑状态下看编辑框内容html；预览状态下看question.QuestionStem
        this.$alert("请先选择或编辑题目！！！");
        return;
      }
      if (this.taskData.isOnline > 1) {
        if (!this.opt.img) {
          //检测当前是否有图片
          this.$alert("还未上传教辅图片", "提示");
          return;
        }
        // console.log(question.ID == 0,this.$refs.crop.cropH == 50 ,this.$refs.crop.cropW == 200)
        if (question.ID == 0 && this.$refs.crop.cropH == 50 && this.$refs.crop.cropW == 200) {
          //检测当前是否有图片
          this.$alert("请先选择或框选题目", "提示");
          return;
        }
      }

      this.searchQuestions(question);
    },

    autoSearchChange(newVal) {
      console.log('自动搜索', newVal);
      localStorage["autoSearchClosed"] = newVal;
    },
    searchQuestions(question) {
      let formData = new FormData();

      let param = {
        Subject: localStorage["subjectID"],
        TaskQuestionID: question.ID,
        QuestionType: question.QuestionType != "" ? question.QuestionType : 0,
        Text: "",
        Imageurl: "",
      };
      if (this.taskData.isOnline == 1) {
        // 在线出题，题干文本搜题，文本取选中的题目的预览文本或编辑状态下的文本框中的文本
        // 如编辑框里没有任何纯文本内容，是粘贴了一张图片，传图片的URL
        console.log(this.html);
        let htmlText =
          this.htmlToText(this.html) != "" || this.html.indexOf("img") != -1 ? this.html : question.QuestionStem;
        if (this.htmlToText(htmlText) == "" && htmlText.indexOf("img") != -1) {
          let s = htmlText.indexOf("https://");
          let e = htmlText.indexOf('"', s);
          let imgUrl = htmlText.substring(s, e);
          param.Imageurl = imgUrl;
        } else {
          param.Text = this.htmlToText(htmlText);
        }
      } else if (question.ID > 0 && !question.Edit) {
        // 传题选题或教辅选页出题，预览状态下传选中题目的题干图片地址，编辑状态下上传最新的框图，此参数传空
        param.Imageurl = question.QuestionStemImage;
      }

      // 填充接口参数
      formData.append("Param", JSON.stringify(param));
      // 传题选题或教辅出题，新框题或是题目编辑状态下上传框的图
      if (this.taskData.isOnline > 1 && (question.ID == 0 || (question.ID > 0 && question.Edit))) {
        this.$refs.crop.getCropData((imgData) => {
          formData.append("Files", this.dataURLtoFile(imgData));
          this.getQuestionBankList(formData);
        });
      } else {
        //无需上传图片文件，直接
        this.getQuestionBankList(formData);
      }
    },
    getQuestionBankList(formData) {
      //调搜题接口
      this.axios
        .post(window.hosturl + "/rest/questionBank/GetQuestionBankList", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.result == 200) {
            this.searchData = res.data.data;
            if (this.searchData.length > 0) {
              this.searchDialog = true;
              if (this.question.SID == null || this.question.SID == '' || this.question.SID == '0') {
                this.question.SID = this.searchData[0].Data.SID;
              }
              /* let that = this;
              setTimeout(function() {
                that.computeOptionCols(that.searchData, "searchData");
              }, 300); */
            } else {
              this.$message.warning("抱歉，没有在题库中搜索到本题！");
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    /* 获取一段HTML文本中的纯文本内容 */
    htmlToText(html) {
      // 创建一个新的DOMParser实例
      var parser = new DOMParser();

      // 使用DOMParser的parseFromString方法将HTML字符串转换为Document对象
      var doc = parser.parseFromString(html, "text/html");

      // 定义一个函数来递归提取所有文本节点的内容
      function extractText(node) {
        var text = "";
        if (node.nodeType === Node.TEXT_NODE) {
          text += node.textContent;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          for (var i = 0; i < node.childNodes.length; i++) {
            text += extractText(node.childNodes[i]);
          }
        }
        return text;
      }

      // 从Document对象的body开始提取文本
      return extractText(doc.body);
    },

    /* 填充题目表单 */
    fillQueForm(que) {
      //一、在线出题文本框编辑题目
      // 1、预览状态下：变成编辑状态并填充替换相关字段（题型、难易程度、正确答案及答案解析）
      // 2、编辑状态新增题：填充相关字段（题型、难易程度、正确答案及答案解析）
      // 3、编辑状态修改题：填充替换相关字段（题型、难易程度、正确答案及答案解析）
      //二、框题图片出题
      // 1、预览状态下：变成编辑状态并填充替换相关字段（题型、难易程度、正确答案及答案解析）
      // 2、编辑状态新框题：填充相关字段（题型、难易程度、正确答案及答案解析）
      // 3、编辑状态修改题：填充替换相关字段（题型、难易程度、正确答案及答案解析）
      if (this.taskData.isOnline == 1) {
        if (this.isReviewOnline) {
          this.editOnlineQuestion(this.question);
        }
      } else {
        if (this.isReviewImgQuestion) {
          this.selectQuestion(this.activeQuestionIndex, true);
        }
      }
      this.question.SID = que.Data.SID;
      this.question.QuestionType = que.Data.QuestionType;
      this.question.DifficultLvl = this.degreeToDifficultLvl(que.Data.Degree);
      if (que.QuestionPoints.length > 0) {
        let points = [];
        for (let p of que.QuestionPoints) {
          let pp = { PointName: p.Value, PointNo: p.Key };
          points.push(pp);
        }
        this.question.KnowledgePoints = points;
      }

      if (this.question.QuestionType == 2) {
        this.question.Answer = [];
        for (let aIndex of que.Answers) {
          this.question.Answer.push(this.optNums[Number(aIndex)]);
        }
      } else {
        this.question.Answer = que.Data.DisplayAnswer;
      }
      if (this.question.QuestionType > 3) {
        this.answerUEditor.setContent(que.Data.DisplayAnswer);
      }
      /* switch (this.question.QuestionType) {
        case 1:
          this.question.Answer = this.optNums[Number(que.Answers[0])];
          break;
        case 2:
          this.question.Answer = [];
          for (let aIndex of que.Answers) {
            this.question.Answer.push(this.optNums[Number(aIndex)]);
          }
          break;
        case 3:
          this.question.Answer = que.Answers[0] == "√" ? "T" : "F";
          break;
        default:
          this.answerUEditor.setContent(que.Data.DisplayAnswer);
          this.question.Answer = que.Data.DisplayAnswer;
      } */

      let explain = "";
      if (que.Data.Method && que.Data.Method.trim() != "") {
        explain = explain + que.Data.Method;
      }
      if (que.Data.Analyse && que.Data.Analyse.trim() != "") {
        explain = explain + "<br>" + que.Data.Analyse;
      }
      this.explainUEditor.setContent(explain);
      this.question.Explain = explain;
      this.searchDialog = false;
      console.log(this.question.Answer);
    },
    /* 搜题结果中查找相似题queIndex:题库题目列表题目序号，questions：题库题目列表 */
    similarQuestions(queIndex, questions) {
      console.log("当前题目", this.question);
      let que = questions[queIndex];
      this.searchSimilar(this.question.ID, que.Data.SID);
    },
    /* 任务单原题查找相似题taskQuestion：要查找相似题的任务单原题，index：原题下标序号 */
    openSimilar(taskQuestion, index) {
      // console.log("要找相似题的原题信息：", taskQuestion);
      if ((this.question.Edit || this.onlineQuestionStatus) && this.html && this.html != "<p><br></p>") {
        this.$alert("当前编辑的题目还未保存.", "提示");
        return;
      }
      // console.log("任务单信息", this.taskData);
      //标记找的哪道题的相似题，换一组查询时有用
      this.similarQuestion = taskQuestion;
      let sid = taskQuestion.SID;
      if (sid && sid != '0') {
        // 原题关联了题库试题sid，使用sid找相似题
        this.searchSimilar(taskQuestion.ID, sid);
      } else {
        // 原题没有关联题库试题sid，传题目题干信息
        this.searchSimilarWithoutSID(taskQuestion);
      }
    },
    // 相似题 - 进入题库挑题
    enterSelectQuestion() {
      console.log('进入题库挑题')
      if (!this.similarQuestion) {
        this.similarQuestion = JSON.parse(JSON.stringify(this.question))
      }
      // 题库挑题弹出框打开
      this.selQuestionDialog = true
    },
    /* 换一组相似题 */
    changeSimilar() {
      let SID;
      let NID = "";
      let similarQuestion = this.similarQuestion ? this.similarQuestion : this.question;
      if (this.similarLoadedData.length + this.similarData.length <= 10) {
        // nid最多支持10个，不超10的情况
        this.similarLoadedData = this.similarLoadedData.concat(this.similarData);
        console.log(this.similarLoadedData);
        if (this.similarLoadedData.length > 0) {
          for (let q of this.similarLoadedData) {
            NID = NID.concat(q.Data.SID + ",");
          }
          NID = NID.substring(0, NID.length - 1);
        }
        console.log(NID);
        SID = similarQuestion.SID ? similarQuestion.SID : this.similarData[0].Data.SID;
      } else {
        // nid已足10个  不能再增加，sid取最新一组数据的第一条
        SID = this.similarData[0].Data.SID;
      }
      // 记录换一组点击的次数
      this.anotherGroupCount++;
      this.searchSimilar(similarQuestion.ID, SID, NID);
    },

    /* 监听相似题窗口关闭，重置已加载的相似题 */
    closeSimilar() {
      this.similarLoadedData = [];
      this.anotherGroupCount = 0;
      this.similarData = [];
      this.similarQuestion = null;
    },

    /* 获取相似题接口，更新数据；taskQuestionID：任务单原题id，SID：题库题目sid */
    searchSimilar(taskQuestionID, SID, NID) {
      this.axios
        .get(
          window.hosturl +
          "/rest/questionBank/GetSimilarQuestions?SID=" +
          SID +
          "&TaskQuestionID=" +
          taskQuestionID +
          "&NID=" + (NID ? NID : "")
        )
        .then((res) => {
          if (res.data.result == 200) {
            this.similarData = res.data.data;
            // this.similarLoadedData = this.similarLoadedData.concat(this.similarData);
            if (this.similarData.length > 0) {
              this.similarDialog = true;
              /* let that = this;
              setTimeout(function() {
                that.computeOptionCols(that.similarData, "similarData");
              }, 300); */
            } else {
              this.$message.warning("抱歉，没有找到！");
            }
          }
        });
    },
    searchSimilarWithoutSID(question) {
      let params = {
        SID: "",
        Subject: localStorage["subjectID"],
        TaskQuestionID: question.ID,
        QuestionType: question.QuestionType != "" ? question.QuestionType : 0,
        Text: "",
        Imageurl: "",
      };
      if (this.taskData.isOnline == 1) {
        // 在线出题，题干文本搜题，
        // 如没有任何纯文本内容，只粘贴了一张图片，传图片的URL
        let htmlText = question.QuestionStem;
        if (this.htmlToText(htmlText) == "" && htmlText.indexOf("img") != -1) {
          let s = htmlText.indexOf("https://");
          let e = htmlText.indexOf('"', s);
          let imgUrl = htmlText.substring(s, e);
          params.Imageurl = imgUrl;
        } else {
          params.Text = this.htmlToText(htmlText);
        }
      } else {
        // 传题选题或教辅选页出题，传选中题目的题干图片地址
        params.Imageurl = question.QuestionStemImage;
      }

      //调搜题接口
      this.axios
        .get(window.hosturl + "/rest/questionBank/GetSimilarQuestions", { params })
        .then((res) => {
          if (res.data.result == 200) {
            this.similarData = res.data.data;
            if (this.similarData.length > 0) {
              this.similarDialog = true;
              question.SID = this.similarData[0].Data.SID;
            } else {
              this.$message.warning("抱歉，没有找到！");
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    closeSelQuestion() {
      this.selQuestionDialog = false  // 关闭题库挑题弹出框
      if (this.similarDialog) {
        this.similarDialog = false // 关闭相似题弹出框
      }
      if (this.searchDialog) {  // 关闭搜题弹出框
        this.searchDialog = false
      }
    },
    /* 打开题目预设的推题列表 */
    openPushed(taskQuestion, index) {
      let that = this;
      this.axios
        .get(window.hosturl + "/rest/questionBank/GetPushQuestionsList?TaskQuestionID=" + taskQuestion.ID)
        .then((res) => {
          if (res.data.result == 200) {
            this.pushedData = res.data.data;

            if (this.pushedData.length > 0) {
              for (let pushQue of this.pushedData) {
                pushQue.PushID = pushQue.Data.ID;
                pushQue.Data.DetailSaved = true;
              }
              this.pushedDialog = true;
              /* let that = this;
              setTimeout(function() {
                that.computeOptionCols(that.pushedData, "pushedData");
              }, 300); */
            } else {
              this.$message.warning("还未预加入任何推题！");
            }
          }
        });
    },
    /* 清空当前题预设的所有推题 */
    clearPushed() { },
    /* 加入推题 */
    addPush(queIndex, queList) {
      let formData = new FormData();

      if (this.question.ID == 0) {
        // 新增题目尚未保存，需提交题目的信息
        if (this.taskData.isOnline > 1) {
          this.$refs.crop.getCropData((imgData) => {
            formData.append("Files", this.dataURLtoFile(imgData));
            this.addPushPost(formData, false, queIndex, queList);
          });
        } else {
          this.addPushPost(formData, false, queIndex, queList);
        }
      } else {
        this.addPushPost(formData, true, queIndex, queList);
      }
    },
    /* 加入推题调接口post */
    addPushPost(formData, queExist, queIndex, queList) {
      let pushQuestion = queList[queIndex];
      console.log(pushQuestion);
      console.log(queExist);
      let param = {};
      if (!queExist) {
        if (this.question.Sort == "") {
          this.question.Sort = this.taskData.Questions.length + 1;
        }
        //解析
        let points = [];
        if (this.question.KnowledgePoints && this.question.KnowledgePoints.length > 0) {
          for (let kp of this.question.KnowledgePoints) {
            points.push(kp.PointNo);
          }
        }
        let Explain = this.explainUEditor.getContent();
        this.question.Explain = Explain;

        if (this.taskData.isOnline == 1) {
          //题干
          //let QuestionStem = this.editorCreate.txt.html();
          this.question.QuestionStem = this.html;

          // 计算题目的高度
          let style = getComputedStyle(this.showQuestion);
          this.question.RegionW = Math.round((this.taskData.TrueWidth / 210) * 793.69);
          this.question.RegionH = parseFloat(style.height);
        } else {
          this.question.RegionX = Math.floor(this.question.RegionX * 100) / 100;
          this.question.RegionY = Math.floor(this.question.RegionY * 100) / 100;
          this.question.RegionW = Math.floor(this.question.RegionW);
          this.question.RegionH = Math.floor(this.question.RegionH);
        }
        param = {
          SID: pushQuestion.Data.SID,
          TaskQuestionID: this.question.ID,
          QuestionType: this.question.QuestionType, //题型
          QuestionStem: this.question.QuestionStem,
          Answer:
            typeof this.question.Answer === "object" ? this.question.Answer.sort().join("") : this.question.Answer, // 正确答案
          Explain: this.question.Explain,
          DifficultLvl: this.question.DifficultLvl,
          RegionX: this.question.RegionX,
          RegionY: this.question.RegionY,
          RegionW: this.question.RegionW,
          RegionH: this.question.RegionH,
          KnowledgePoints: points,
          Score: this.question.Score,
          QuestionBankSID: this.question.SID,
          ExercisePageId:
            this.taskData.isOnline == 3 && this.taskPages[this.paginationOpt.currentPage - 1]
              ? this.taskPages[this.paginationOpt.currentPage - 1].ExercisePageId
              : 0,
          TaskListID: this.taskData.TaskListID, //任务单id
          TaskPageID:
            this.taskData.isOnline > 1
              ? this.taskPages[this.paginationOpt.currentPage - 1].ID ||
              this.taskPages[this.paginationOpt.currentPage - 1].PageID
              : 0,
        };
      } else {
        param = {
          SID: pushQuestion.Data.SID,
          TaskQuestionID: this.question.ID,
          TaskListID: this.taskData.TaskListID, //任务单id
        };
      }
      // 填充接口参数
      formData.append("Param", JSON.stringify(param));
      //调搜题接口
      this.axios
        .post(window.hosturl + "/rest/questionBank/JoinThePushQuestion", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.result == 200) {
            let data = res.data.data;

            if (this.question.PushCount && this.question.PushCount >= 0) {
              this.question.PushCount += 1;
            } else {
              this.question.PushCount = 1;
            }
            if (!this.question.ID) {
              this.question.ID = data.TaskQuestionID;
              this.question.Sort = data.TaskQuestionSort;
              if (data.path) {
                this.question.QuestionStemImage = data.path;
              }
              if (this.taskData.IsOnline > 1) {
                this.taskPages[this.paginationOpt.currentPage - 1].Questions.splice(
                  this.question.Sort - 1,
                  1,
                  this.question
                );

                //把所有页的题目组合到一个数组中,并按题号排序
                this.taskData.Questions = [];
                //组合题目.
                this.taskPages.forEach((item) => {
                  let ql = item.Questions;
                  this.taskData.Questions = this.taskData.Questions.concat(ql);
                });
                this.taskData.Questions.sort((a, b) => {
                  return a.sort - b.sort;
                });
              } else {
                this.taskData.Questions.push(this.question);
              }
            }
            pushQuestion.PushID = data.PushID;
            queList.splice(queIndex, 1, pushQuestion);
            this.$message.success("已加入推题");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    /* 移出推题 */
    removePush(queIndex, queList) {
      let pushQuestion = queList[queIndex];
      //调搜题接口
      this.axios
        .post(window.hosturl + "/rest/questionBank/PushQuestionRemove", {
          ID: pushQuestion.PushID,
        })
        .then((res) => {
          if (res.data.result == 200) {
            pushQuestion.PushID = 0;
            queList.splice(queIndex, 1, pushQuestion);
            if (this.question.PushCount && this.question.PushCount > 0) {
              this.question.PushCount -= 1;
            }
            this.$message.success("已移出推题");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    openPushEdit(queIndex, queList) {
      this.pushChangeIndex = queIndex;
      this.pushChangeQue = queList[queIndex];
      console.log(this.pushChangeQue);
      this.editDialog = true;
    },
    savePushChanged(que) {
      this.pushedData.splice(this.pushChangeIndex, 1, que);
      this.editDialog = false;
    },
    cancelPushChanged(que) {
      this.editDialog = false;
    },
    closePushEdit() {
      this.pushChangeIndex = -1;
      this.pushChangeQue = {
        Data: {},
        Answers: [],
        Options: [],
        SourceReports: [],
        QuestionChidren: [],
        PushID: 0,
      };
    },
    /* 难度系数（小数）转换成难度等级（int） */
    degreeToDifficultLvl(degree) {
      if (degree >= 1) {
        return 0;
      } else if (degree >= 0.8) {
        return 1;
      } else if (degree >= 0.6) {
        return 2;
      } else if (degree >= 0.4) {
        return 3;
      } else if (degree >= 0.2) {
        return 4;
      } else if (degree > 0) {
        return 5;
      } else {
        return 0;
      }
    },

    /* 搜题相关 end-------------------- */


    handleQuestionListChange() {
      // console.log(this.taskPages,this.fastNowPage);

      const page = this.taskPages && this.taskPages[this.paginationOpt.currentPage - 1];
      // console.log(!page, !page.questionList);

      if (!page || !page.Questions) return;
      // console.log(this.taskPages,page)
      const val = page.Questions;
      console.log(val)
      const list = [...val].sort((a, b) => a.Sort - b.Sort);
      this.sortedQuestionList = list.map(x => {
        return {
          QuestionID: x.ID,
          QuestionNum: x.QuestionNum,
          Sort: x.Sort
        }
      });
    },
  },
  created() {
    this.getTeachingMaterialForTeacher()

  },
  mounted() {
    this.init();

    // 调试：检查后端配置接口
    this.checkUEditorConfig();

    // UEditor 安全配置
    const secureConfig = {
      serverUrl: window.hosturl + "/UEditor/Handler",
      // 限制文件大小
      imageMaxSize: 5 * 1024 * 1024,  // 5MB
      videoMaxSize: 50 * 1024 * 1024, // 50MB
      fileMaxSize: 10 * 1024 * 1024,  // 10MB
      // 限制文件类型
      imageAllowFiles: ['.jpg', '.jpeg', '.png', '.gif', '.bmp'],
      videoAllowFiles: ['.mp4', '.avi', '.wmv', '.flv'],
      fileAllowFiles: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt'],
      // 禁用远程图片抓取（防止 SSRF 攻击）
      catchRemoteImageEnable: false,
      // 禁用图片管理和文件管理（防止信息泄露）
      imageManagerActionName: '',
      fileManagerActionName: '',
      // XSS 过滤
      xssFilterRules: true,
      inputXssFilter: true,
      outputXssFilter: true
    };

    const ue1 = UE.getEditor("UEcontainer1", secureConfig);
    this.answerUEditor = ue1;
    
    const ue2 = UE.getEditor("UEcontainer2", secureConfig);
    this.explainUEditor = ue2;
    
    // 监听编辑器就绪事件，添加安全验证
    ue1.ready(() => {
      // 监听图片插入前事件，验证图片来源
      ue1.addListener('beforeInsertImage', (t, args) => {
        // 过滤非本站图片
        const filteredArgs = args.filter(url => {
          return url.startsWith(window.hosturl) || url.startsWith('/uploads') || url.startsWith('/net');
        });
        if (filteredArgs.length !== args.length) {
          this.$message.warning('已过滤非本站图片');
        }
        return filteredArgs;
      });
    });
    
    ue2.ready(() => {
      ue2.addListener('beforeInsertImage', (t, args) => {
        const filteredArgs = args.filter(url => {
          return url.startsWith(window.hosturl) || url.startsWith('/uploads') || url.startsWith('/net');
        });
        if (filteredArgs.length !== args.length) {
          this.$message.warning('已过滤非本站图片');
        }
        return filteredArgs;
      });
    });
  },

  watch: {
    taskID(newVal, oldVal) {
      this.getTaskInfo(this.taskID, this.taskType);
    },
    //检测 isEditQuestion , 如呆为false时裁图会重新加载
    isEditQuestion(newVal, oldVal) {
      if (newVal === false) {
        this.$nextTick().then(() => {
          this.cutImgs = document.getElementById("cutImgs");
        });
      }
    },
    taskPages: {
      handler(newVal, oldVal) {
        // console.log('taskPages变了-------',newVal)
        this.handleQuestionListChange();
      },
      deep: true,
    },
  },
  computed: {
    addPadding: {
      get: function () {
        return {
          paddingTop: false,
          paddingBottom: false,
        };
      },
      // setter
      set: function (i) {
        if (i === 0) {
          this.paddings[0] = {
            paddingTop: true,
            paddingBottom: false,
          };
        }
      },
    },
  },

  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
    if (this.answerUEditor == null) return;
    this.answerUEditor.destroy(); // 组件销毁时，及时销毁编辑器

    if (this.explainUEditor != null) {
      this.explainUEditor.destroy(); // 销毁编辑器实例
    }
  },
};
</script>
<style lang="less"></style>
<style lang="less" scoped>
/deep/ .w-e-text-container {
  min-height: 120px;
  padding: 0;

  [data-slate-editor] {
    padding: 0;
  }

  p {
    margin: 10px 0;
    line-height: 1.5;
    font-size: 10.5pt !important;
    word-break: normal;

    strong {
      font-weight: 600;
    }
  }

  .w-e-text-placeholder {
    left: 0;
    top: 10px;
    font-style: normal;
    line-height: normal;
  }
}

/deep/.searchDialog {
  border-radius: 10px;
  max-height: 80vh;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &.sel-question-dialog {
    max-height: none !important;

    .el-dialog__body {
      padding: 0;
    }

    .el-dialog.similar-dialog {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;

      .el-dialog__body {
        max-height: 800px;
      }
    }
  }

  .el-dialog__header {
    padding: 10px 20px 10px;
    border-radius: 10px 10px 0 0;
    background: #2489f6 !important;
    color: #fff;

    .similar-title {
      display: flex;
      justify-content: space-between;
      color: #fff;

      .extra-btns {
        display: flex;
        align-items: center;
        margin-right: 70px;

        .enter-question-selection {
          margin-right: 50px;
        }

        a.change {
          color: #fff;
        }
      }
    }

    .el-dialog__headerbtn {
      top: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
      }
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #fff;
    }

    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #fff;
    }

    .el-checkbox__inner {
      background-color: transparent;
      border-color: #fff;
    }

    a.change-one {
      color: #fff;
      // position: absolute;
      // top: 12px;
      // right: 100px;

      i {
        margin-right: 5px;
      }
    }
  }

  .el-dialog__body {
    overflow: auto;
    flex: 1;

    .searchIndex {
      display: flex;
      flex-direction: column;

      .query {
        margin: 15px 15px 5px 15px;
        border: 1px solid #b1afaf;
        border-radius: 10px;

        .analysis {
          margin-left: 20px;

          p {
            margin-bottom: 15px;
          }
        }

        .footer {
          display: flex;
          justify-content: space-between;
          border-radius: 10px;
          background: #eee;

          .info {
            line-height: 35px;
            margin-left: 10px;

            span {
              margin-left: 10px;
            }
          }

          .operate {
            margin-top: 3px;
            margin-right: 5%;
          }
        }
      }
    }
  }
}

/* .search {
} */

.taskCreate {
  position: relative;
  /*left: 20px;
  right: 20px;
  bottom: 20px;
  top: 20px;*/
  background: #fff;
  padding-top: 1.25rem;

  /deep/ .el-loading-mask {
    z-index: 99999;
  }

  .el-pagination {
    text-align: center;
    margin-top: 20px;
  }

  .header1 {
    padding: 0 1.25rem;
    margin-bottom: 10px;
  }

  .header {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 0 1.25rem;
    margin-bottom: 10px;

    .el-checkbox-group {
      padding-top: 3px;
    }

    span {
      width: 70px;
      text-align: right;
      line-height: 28px;
      display: block;
      margin-right: 10px;
    }

    .el-input {
      /*flex: 1 1 auto;*/
      width: 6rem;
    }

    .el-input-number {
      width: 7rem;
    }

    .el-button {
      margin-left: 10px;
      /*width: 126px;*/
    }

    .el-cascader {
      flex: auto;
    }

    /deep/ .el-input__suffix {
      display: flex;
      align-items: center;
    }

    .teachingMaterial {
      line-height: 32px;
      margin: 0 10px 0 20px;
    }

    .select-size.el-select {
      width: 9rem;
    }

    &.head1 {
      /deep/ .el-date-editor {
        flex: 0 0 auto;
        width: 150px;
      }

      .el-button {
        width: 80px;
        padding: 9px 9px;
      }

      .el-select {
        flex: 1 1 auto;
      }

      .otherbtns {
        position: absolute;
        right: 20px;
      }
    }
  }

  .question {
    /*position: absolute;
    top: 220px;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0 1.25rem;
    padding-bottom: 10px;*/
    display: flex;
    flex-direction: column;
    text-align: left;
    position: sticky;
    top: 0;

    .btns {
      display: flex;
      justify-content: space-between;
      position: sticky;
      top: 0px;
      z-index: 100;
      background: #fff;

      .btns-left {
        display: flex;
        justify-content: space-between;
        width: 210mm;

        .el-button {
          border-radius: 0;
        }
      }

      /*分页*/

      .el-pagination {
        margin-top: 0;
        margin-left: -10px;
      }

      .otherBtns {
        display: flex;
      }

      .active {
        background: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .taskCut {
      /*position: absolute;
      top: 28px;
      right: 20px;
      bottom: 10px;
      left: 20px;*/

      h3 {
        font-size: 18px;
        background: #eee;
        color: #000;
      }

      .cut {
        height: 100%;
        display: flex;

        .autoQuestion {
          height: 100%;
          box-sizing: content-box;
          width: 230mm;
          min-width: 230mm;
          position: relative;
          color: #000;

          //顶部的工具栏
          .editorCreateTools {
            position: sticky;
            top: 0px;
            z-index: 1;
            border: 1px solid #dddddd;

            /deep/ .w-e-toolbar {
              background: #eee;
              z-index: 9999 !important;
            }
          }

          .editorCreate {
            //实际上宽度是230mm.
            /*position: absolute;
            top: 40px;
            left: 0;
            right: 0;
            bottom: 0;*/
            background: #f9f9f9;
            // border: 1px solid #ddd;
            border-right: 0;
            overflow: auto;
            font-size: 10.5pt;

            .Questions {
              //共有的questions
              background: #fff;
              height: auto;
              position: relative;
              margin: 0 10mm;
              padding: 10mm;

              .question-item {
                box-sizing: border-box;
                /*这里算上了左右边框,实际上是793.69px==210mm*/
                margin: 0 auto;

                &.w-e-text {
                  padding: 0;
                  overflow: visible;
                  word-break: normal;
                }

                .questionContent {
                  box-sizing: border-box;
                  /*padding: 0 49.69px;*/
                  padding: 0;
                  position: relative;
                  background: #fff;
                  border: 1px solid rgba(0, 0, 0, 0);

                  &.active {
                    border: 1px solid #f00 !important;
                  }

                  .questionHtml {
                    // padding: 0 10px;
                    // border: 1px solid rgba(0, 0, 0, 0);
                    font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
                    font-size: 10.5pt;
                    overflow: hidden;

                    /deep/ a {
                      color: rgb(0, 0, 238);
                    }
                  }

                  .push-count {
                    position: absolute;
                    right: -15px;
                    top: -15px;
                    background: #fd694c;
                    color: #fff;
                    width: 30px;
                    height: 30px;
                    border: 0;
                    border-radius: 15px;
                    line-height: 30px;
                    text-align: center;
                    font-size: 14px;
                    cursor: pointer;
                  }

                  .btns {
                    display: none;
                    /* position: absolute;
                    height: 100%;
                    right: -45px;
                    top: 0;
                    width: 50px; */
                    position: absolute;
                    height: 32px;
                    line-height: 30px;
                    right: 0px;
                    bottom: 0px;
                    width: 295px;
                    top: unset;
                    border: 1px solid #2489f6;

                    .btn {
                      /* position: absolute;
                      top: 50%;
                      left: 0;
                      right: 0;
                      transform: translateY(-50%); */
                      width: 100%;
                      height: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: right;

                      span,
                      a {
                        text-decoration: none;
                        cursor: pointer;
                        /* font-weight: bold; */
                        font-size: 0.8rem;
                        color: #2489f6;
                        margin: 0 6px;

                        /* &:nth-child(1) {
                          color: #e6a23c;
                        }

                        &:nth-child(2) {
                          color: #f56c6c;
                        }

                        &:nth-child(5) {
                          color: #409eff;
                        }

                        &:nth-child(4) {
                          color: #409eff;
                        } */
                      }
                    }
                  }

                  &.paddingTop {
                    padding-top: 10mm;
                  }

                  &.paddingBottom {
                    padding-bottom: 10mm;
                  }
                }

                .splitPage {
                  height: 30px;
                }

                &:hover {
                  .questionContent {
                    border: 1px solid #ddd;
                  }

                  .btns {
                    display: block;
                  }
                }

                //即时显示
                &.question-item-show {
                  position: absolute;
                  width: 100%;
                  height: 200px;
                  background: #000;
                }
              }

              //导出pdf
              &.questionsPrint {
                position: absolute;
                z-index: -9999;
                left: -99999px;
                background: #fff;
                width: 210mm;
                height: 297mm;
                font-weight: normal;
                font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
              }

              &.reviewQuestion {
                position: fixed;
                z-index: 99999;
                left: 50%;
                transform: translateX(-50%);
                background: #fff;
                width: 210mm;
                top: 20px;
                bottom: 20px;
                height: auto;
                overflow-y: auto;
                font-weight: normal;
                font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
                border: 5px solid #000;

                .printAndExport {
                  position: fixed;
                  transform: translateY(-50%);
                  right: 20px;

                  .el-button {
                    padding: 5px 20px;
                    width: 80px;
                    font-weight: bold;
                  }
                }
              }
            }

            .question2ImgForPrint {
              position: absolute;
              z-index: -9999;
              left: -99999px;
              width: 210mm;
              height: 297mm;
              /*padding:10mm;*/
              font-weight: normal;
              font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
              -webkit-font-smoothing: antialiased;
            }

            //下面的编辑区.
            .editorCreateContainer {
              min-height: 120px;
              margin: 0 10mm;
              padding: 0 10mm;
              background: #fff;
              /*border: 1px solid #eee;*/
              border-top: 30px solid #f9f9f9;
              border-left: 0;
              border-right: 0;

              /deep/ .w-e-text-container {
                /* z-index: 9998 !important; */
                min-height: 120px;
                /*计算如果不对就按上面的来.*/
                font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;

                .w-e-text {
                  word-break: normal;
                  padding: 0;

                  a {
                    color: rgb(0, 0, 238);
                  }

                  img {
                    vertical-align: top !important;
                  }
                }

                .placeholder {
                  left: 0px;
                }
              }
            }

            //保存按钮.
            .saveQuestion {
              text-align: right;
              background: #f9f9f9;

              .dv {
                margin: 0 auto;
                height: 48px;
                /*background: #FFF;*/
                /*position: absolute;*/
                padding: 10px 10mm;
              }
            }

            //即时显示框
            .showQuestion {
              position: absolute;
              /*width: 100%;*/
              z-index: -999;
            }
          }
        }

        .imageQuestion {
          border-right: 1px solid #ddd;
          height: 100%;
          /*width: 176mm;*/

          .cutImgQuestion {
            height: 100%;
            overflow: auto;

            .cutImg {
              /*width: 176mm;
              height: 250mm;
              min-width: 176mm;
              min-height: 250mm;*/
              position: relative;

              div.questionLine {
                position: absolute;
                border: 8px solid #f00;
              }

              div.questionLineHover {
                position: absolute;
                border: 8px solid #f00;
              }
            }
          }

          .reviewImg {
            position: fixed;
            z-index: 99999;
            left: 50%;
            transform: translateX(-50%);
            background: #fff;
            width: 220mm;
            top: 20px;
            bottom: 20px;
            height: auto;
            overflow-y: auto;
            font-weight: normal;
            font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
            border: 5px solid #000;

            .page {
              width: 210mm;
              height: 297mm;
              border: 1px solid #ddd;
              margin-bottom: 20px;

              img {
                width: 100%;
              }
            }

            .printAndExport {
              position: fixed;
              transform: translateY(-50%);
              right: 20px;

              .el-button {
                padding: 5px 20px;
                width: 80px;
                font-weight: bold;
              }
            }
          }
        }

        /*右侧题目设定*/

        .cutSeeting {
          display: flex;
          flex: 1 1 auto;
          border-left: 1px solid #ddd;

          h4 {
            color: #fff;
            background: #409eff;
            padding: 3px 0 2px;
            font-size: 16px;
            text-align: center;
          }

          .taskTree {
            border: 1px solid #ddd;
            width: 150px;
            text-align: left;

            ul.treeContent {
              &:hover {
                cursor: pointer;
              }

              padding: 0 10px;
              font-size: 16px;

              ol.treeItem {
                padding: 0 10px 0 20px;
                font-size: 14px;

                li {
                  padding-left: 10px;
                }

                li.hover {
                  background: #67c23a;
                  color: #fff;
                }

                li.create {
                  background: #00f;
                  color: #fff;
                }
              }
            }
          }

          .taskSet {
            flex: 1 1 auto;
            text-align: left;
            border: 1px solid #ddd;
            border-left: 0;
            position: relative;
            display: block;

            .questionBtn {
              padding: 0 15px;
            }

            .taskForm {
              position: sticky;
              top: 30px;
              padding: 0 15px;

              /* /deep/ .w-e-text-container {
                z-index: 9998 !important;
              } */

              /deep/ .w-e-toolbar {
                z-index: 9999 !important;
              }

              /deep/ .el-form-item__content {
                z-index: 9999 !important;
              }

              .position {
                /deep/ .el-form-item__content {
                  z-index: 9999 !important;
                  display: flex;
                  justify-content: space-between;

                  .el-input {
                    width: 60%;
                  }
                }
              }

              .el-form-item {
                margin-bottom: 0;

                /deep/ .w-e-text-container {
                  min-height: 60px;
                  margin: 0 10px;
                  /*height: auto !important;*/

                  .w-e-text {
                    word-break: normal;
                    min-height: 60px !important;
                    /*height: auto !important;*/
                  }
                }

                .el-select {
                  display: block;
                }

                /deep/ .el-form-item__label {
                  padding-bottom: 0;
                }
              }

              /deep/ .el-form-item {
                &.must {
                  position: relative;

                  label.el-form-item__label:before {
                    content: "*";
                    /*font-size: 14px;*/
                    color: #f00;
                    position: absolute;
                    top: 3px;
                    left: -7px;
                  }
                }
              }
            }

            .question-num-list-wrap {
              width: 100%;
              margin: 10px 0;
              padding: 0 10px;

              .question-num-list {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
              }

              .question-num-item {
                min-width: 38px;
                min-height: 26px;
                padding: 4px 7px;
                background: #f5f7fa;
                border: 1px solid #dcdfe6;
                border-radius: 6px;
                text-align: center;
                margin-bottom: 8px;
                cursor: grab;
                user-select: none;
                transition: box-shadow 0.2s;



                &:hover {
                  box-shadow: 0 2px 8px #d3e0f7;
                  background: #e6f7ff;
                }
              }
            }
          }
        }
      }
    }
  }

  #questionsPrint,
  #question2ImgForPrint {
    position: absolute;
    z-index: -9999;
    left: -99999px;
    top: -99999px;
    width: 210mm;
    height: 297mm;
    font-weight: normal;
    font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;

    .question-item {
      box-sizing: border-box;
      /*这里算上了左右边框,实际上是793.69px==210mm*/
      width: 210mm;
      margin: 0 auto;
      min-width: 210mm;
      color: #000;

      &.w-e-text {
        word-break: normal;
        padding: 0;
        overflow: visible;
      }

      .questionContent {
        box-sizing: border-box;
        /*padding: 0 49.69px;*/
        padding: 0 10mm;
        position: relative;
        background: #fff;

        .questionHtml {
          /*padding: 0 10px;*/
          font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
          font-size: 10.5pt;
          text-align: left;

          /deep/ a {
            color: rgb(0, 0, 238);
          }
        }
      }

      .splitPage {
        height: 30px;
      }

      //即时显示
      &.question-item-show {
        position: absolute;
        width: 100%;
        height: 200px;
        background: #000;
      }
    }
  }

  .teachingMaterial {
    .el-cascader {
      display: block;
    }

    .el-select {
      display: block;
    }
  }
}

//教辅资料
#teachingAuxiliaryDialog {
  .headTitle {
    position: relative;
    text-align: center;
    font-weight: bold;
    font-size: 20px;

    .el-icon-back {
      position: absolute;
      left: 0;
    }
  }

  /deep/ .el-dialog .el-dialog__body {
    position: relative;
    padding: 1.5rem;
    text-align: left;
  }

  .teachingAuxiliaryDialogBody {
    .condition {
      margin-bottom: 10px;

      .el-input {
        width: 30%;
      }

      .btnSel {
        background: #378bff;
        color: #fff;
      }
    }

    .pageCondition {
      position: relative;
      margin-bottom: 20px;
      display: flex;

      span {
        line-height: 32px;
      }

      .el-select {
        margin-left: 20px;
        flex: 1 1 auto;
      }

      .el-button {
        margin-left: 10px;
      }
    }
  }
}

.score-dialog {
  /deep/ .el-dialog {
    height: 500px;

    .el-dialog__header {
      background: #409eff;
      color: white;

      .el-dialog__close {
        color: white;
      }
    }

    .el-dialog__body {
      padding: 10px 20px;
      overflow: auto;
      position: absolute;
      bottom: 60px;
      top: 60px;
    }

    .el-dialog__footer {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      text-align: center;
      background: aliceblue;
      padding: 10px 20px 15px;

      button {
        margin: 0 10px;
        padding: 9px 30px;
      }
    }
  }

  table {
    width: 100%;
    border: 1px solid #cccccc;
    border-right: none;
    border-bottom: none;
    color: #333333;

    thead {
      background: #dddddd;
    }

    th,
    td {
      border-right: 1px solid #cccccc;
      border-bottom: 1px solid #cccccc;
      height: 36px;
      padding: 0 10px;

      input {
        width: 100px;
        border: 1px solid #dcdfe6;
        padding: 5px 10px;
        margin: 0 5px;

        &:focus {
          outline: none;
          border-color: #409eff;
        }
      }
    }
  }
}
</style>

<style lang="less">
.w-e-text img {
  vertical-align: top;
}

.w-e-toolbar .w-e-menu {
  width: 34px;
}

.w-e-toolbar p,
.w-e-text-container p,
.w-e-menu-panel p {
  font-size: 10.5pt !important;
}

/*.dateLayer {*/
/*  z-index: 10105 !important;*/
/*}*/

.editorDisable {
  .w-e-toolbar {
    background: #f5f7fa !important;
  }

  .w-e-text-container {
    background: #f5f7fa !important;
  }
}

.selList {
  width: 75%;

  .el-select-dropdown__list {
    display: flex;
    flex-wrap: wrap;

    .el-select-dropdown__item {
      width: 100px;
      text-align: center;
      padding: 0 40px 0 20px;
    }
  }
}

/deep/ .el-link.el-link--primary {
  color: #444;
}

/deep/ .el-link.el-link--primary:hover {
  color: #ed4014;
}

/deep/ .el-link.el-link--primary:after {
  border-color: #ed4014;
}

/deep/ .el-link.is-underline:hover:after {
  border-bottom: 1px solid #ed4014;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/TaskCreate.vue